import React from 'react';
import { userService } from "./../../services/user.service";
import CommonMessage from './../common/commonMessage';
import Validate from '../common/validate';
import { findAllByDisplayValue } from '@testing-library/react';
import { SshkeyService } from './../../services/sshkey.service';
import { Redirect } from 'react-router-dom';
import ReactToolTip from 'react-tooltip';
import { SessionService } from './../../services/session.service';
import { AuditLog } from './../../services/auditlog.service';
import $ from 'jquery';
import { API_HOST, axiosRequestWithAuth, axiosInstance, EMAIL_TRANSFER_TOKEN } from './../../constants/server.constant';
import { ResourceService } from './../../services/resource.service';
import ReCAPTCHA from "react-google-recaptcha";
import { loginService } from '../../services/login.service';
import ReactTooltip from 'react-tooltip';

export default class ProfileDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isChangePsswdPopup: false,
            isCancelMyAccount: false,
            isPhoneVerifyPopup: false,
            hideCancelPopupPwd: true,
            roleId: localStorage.getItem("roleId"),
            userId: localStorage.getItem("userId"),
            firstName: "",
            lastName: "",
            email: "",
            countryCode: "USA +1",
            countryLabel: "USA +1",
            phone: "",
            cancelreason: "",
            cancelcomments: "",
            cancelpassword: "",
            cancelphone: "",
            cancelemail: localStorage.getItem("email"),
            changePsswdForm: {
                currentPsswd: '',
                newPsswd: '',
                confirmPsswd: ''
            },
            psswdStrength: '',
            message: "",
            msgType: '',
            curpswderror: false,
            confirmpswderror: false,
            pswdregex: false,
            pswdempty: false,
            curpswdempty: false,
            emailerror: false,
            firstnameempty: false,
            lastnameempty: false,
            emailempty: false,
            countrycodeempty: false,
            phoneempty: false,
            firstnameregex: false,
            lastnameregex: false,
            emailregex: false,
            phoneregex: false,
            cancelpswdempty: false,
            cancelphoneempty: false,
            cancelmailempty: false,
            cancelreasonempty: false,
            cancelcommentsempty: false,
            getcurpswd: false,
            getnewpswd: false,
            getConfmPass: false,
            invalidemail: false,
            invalidpassword: false,
            invalidphone: false,
            isAction: false,
            isEmailTransferAction: false,
            ispswdsame: false,
            iscancelloader: false,
            issaveenable: false,
            redirect: false,
            isPaswdUpdateDisable: false,
            isUserSubscribed: false,
            isPswdVisible: false,
            otp: "",
            otpempty: false,
            otpErr: false,
            npSpecial: false,
            sevenChars: false,
            twentyChars: false,
            showVerifyLoader: false,
            isthirdpartylogin: false,
            showSetPswdPopup: false,
            isResend: false,
            pendingEmailTransfer: null,
            showEmailUpdateError: false,
            updatedEmail: "",
            invalidUpdatedEmail: false,
            currPwd: "",
            isEmailUpdatePopupActive: false,
            allowEmailUpdateRequest: false,
            isResendEmailUpdateEmailActive: false,
            thirdPartyName: 'Google',
            showPopupMsg_eu: false,
            popupMsg_eu: "",
            popupMsgType_eu: "success",
            isTotpEnabled: false,
            showTotpEnabledMsg: true
        };
        this.firstNameFocus = React.createRef();
        this.lastNameFocus = React.createRef();
        this.emailFocus = React.createRef();
        this.phoneNumberFocus = React.createRef();
        this.cancelPswdFocus = React.createRef();
        this.cancelPhoneFocus = React.createRef();
        this.cancelReasonFocus = React.createRef();
        this.cancelCommentsFocus = React.createRef();
        this.currentPsswdFocus = React.createRef();
        this.changeNewPassword = React.createRef();
        this.changeConfirmPassword = React.createRef();
        this.updateEmailPswdFocus = React.createRef();
        this.enablePopupPassword = this.enablePopupPassword.bind(this);
        this.enableCancelPassword = this.enableCancelPassword.bind(this);
        this.hidePsswd = this.hidePsswd.bind(this);
        this.ChangePsswdHandler = this.ChangePsswdHandler.bind(this);
        this.changePsswdFormSubmit = this.changePsswdFormSubmit.bind(this);
        this.handleInputs = this.handleInputs.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.cancelSubuserAcccont = this.cancelSubuserAcccont.bind(this);
        this.keepMyAcccount = this.keepMyAcccount.bind();
        this.cancelAccountFirstPopup = this.cancelAccountFirstPopup.bind(this);
        this.showCurPswd = this.showCurPswd.bind(this);
        this.escfunction = this.escfunction.bind(this);
        this.inputFocus = this.inputFocus.bind(this);
        this.clearStorage = this.clearStorage.bind(this);
        this.cancelPasswdShow = this.cancelPasswdShow.bind(this);
        this.closePasswordPopup = this.closePasswordPopup.bind(this);
        this.editPasswordFocus = this.editPasswordFocus.bind(this);
        this.handleEnterKey = this.handleEnterKey.bind(this);
        this.cancelPopup = this.cancelPopup.bind(this);
        this.checkForSubscription = this.checkForSubscription.bind(this);
        this.verifyOtp = this.verifyOtp.bind(this);
        this.sendOtp = this.sendOtp.bind(this);
        this.checkPhoneRegex = this.checkPhoneRegex.bind(this);
        this.otpInput = React.createRef();
        this.handleOTPKeyUp = this.keyUpHandler.bind(this, 'otpInput');
        this.recaptchaRef = React.createRef();
    }

    keyUpHandler(refName, e) {
        if(refName == "otpInput") {
            if(e.keyCode === 13) {
                this.verifyOtp();
            }
            this.toggleVerifyButton();
        }
    }

    handleEnterKey = (event) => {
        if(event.keyCode === 13) {
            this.changePsswdFormSubmit(event);
        }
    };

    returnKeyHandler = (event) => {
        if(event.keyCode === 13 && event.target.nodeName !== "INPUT") {
            event.target.click();
            event.stopPropagation();
        }
    };

    detailEnterKey = (event) => {
        if(event.keyCode === 13) {
            this.saveChanges();
        }
    };

    cancelPopup = () => {
        $(".cancel_acc_step1").removeClass("hide");
        $(".cancel_acc_step1").removeClass("show");
        $(".cancel_acc_step2").removeClass("show");
        $(".cancel_acc_step2").removeClass("hide");
        $("body").removeClass("popup_no_scroll");
        this.setState({
            isCancelMyAccount: false
        });
    };

    editPasswordFocus = (event, param) => {
        if(param === "newpaswd") {
            if(this.state.changePsswdForm.currentPsswd.length <= 0) {
                this.setState({
                    curpswdempty: true
                });
            }
            if(this.state.changePsswdForm.currentPsswd.length > 0) {
                this.setState({
                    curpswdempty: false
                });
            }
        }
        else if(param === "cnfrmpswd") {
            if(this.state.changePsswdForm.newPsswd.length <= 0) {
                this.setState({
                    pswdempty: true
                });
            }
            if(this.state.changePsswdForm.currentPsswd.length <= 0) {
                this.setState({
                    curpswdempty: true
                });
            }
            if(this.state.changePsswdForm.newPsswd.length > 0) {
                this.setState({
                    pswdempty: false
                });
            }
            if(this.state.changePsswdForm.currentPsswd.length > 0) {
                this.setState({
                    curpswdempty: false
                });
            }
        }

    };
    clearStorage = () => {
        localStorage.clear();
        sessionStorage.clear();
        SessionService.removeCookie("token");
        return true;
    };

    closePasswordPopup = (e) => {
        e.preventDefault();
        this.setState({ isChangePsswdPopup: false, isPaswdUpdateDisable: false });
        $("body").removeClass("popup_no_scroll");
    };

    cancelPasswdShow = () => {
        this.setState({
            hideCancelPopupPwd: !this.state.hideCancelPopupPwd,
            isCancelPswd: !this.state.isCancelPswd
        });
    };

    inputFocus = (event, param) => {
        if(param === "phoneNumber") {
            if(this.state.cancelpassword.length <= 0) {
                this.setState({
                    cancelpswdempty: true
                });
            }
            else {
                this.setState({
                    cancelpswdempty: false
                });
            }
        }

        else if(param === "options") {
            if(this.state.cancelpassword.length <= 0) {
                this.setState({
                    cancelpswdempty: true
                });
            }
            else {
                this.setState({
                    cancelpswdempty: false
                });
            }
            if(this.state.cancelphone.length <= 0) {
                this.setState({
                    cancelphoneempty: true
                });
            }
            else {
                this.setState({
                    cancelphoneempty: false
                });
            }
        }
        else if(param === "comments") {
            if(this.state.cancelpassword.length <= 0) {
                this.setState({
                    cancelpswdempty: true
                });
            }
            else {
                this.setState({
                    cancelpswdempty: false
                });
            }
            if(this.state.cancelphone.length <= 0) {
                this.setState({
                    cancelphoneempty: true
                });
            }
            else {
                this.setState({
                    cancelphoneempty: false
                });
            }
            if(this.state.cancelreason.length <= 0) {
                this.setState({
                    cancelreasonempty: true
                });
            }
            else {
                this.setState({
                    cancelreasonempty: false
                });
            }
        }
    };

    escfunction(event) {
        if(event.keyCode === 27) {
            this.setState({
                isChangePsswdPopup: false,
                isCancelMyAccount: false,
                isEmailUpdatePopupActive: false,
            });
            $(".cancel_acc_step1").removeClass("hide");
            $(".cancel_acc_step2").removeClass("hide");
            $(".cancel_acc_step1").removeClass("show");
            $(".cancel_acc_step2").removeClass("show");
            $("body").removeClass("popup_no_scroll");
            this.closeEmailUpdatePopup();
            this.closePhoneVerifyPopup();
        }
    }

    componentWillUnmount() {
        clearInterval(this.timerId);
        document.removeEventListener("keyup", this.escfunction, false);
        document.removeEventListener("keydown", this.returnKeyHandler, true);
        document.removeEventListener("click", this.emailUpdatePopupFocusHandler, true);
        clearTimeout(sessionStorage.popupMsgTimeout_eu);
    }

    componentDidMount() {
        document.title = 'IDrive® Compute';
        document.addEventListener("keyup", this.escfunction, false);
        document.addEventListener("keydown", this.returnKeyHandler, true);
        document.addEventListener("click", this.emailUpdatePopupFocusHandler, true);
        this.setState({
            isAction: true
        });
        userService.getUser().then(res => {
            this.checkForSubscription();
            if(res?.data) {
                this.setState({
                    firstName: res.data.firstName === null ? "" : res.data.firstName,
                    lastName: res.data.lastName === null ? "" : res.data.lastName,
                    email: res.data.email === null ? "" : res.data.email,
                    phone: res.data.phone === null ? "" : res.data.phone,
                    countryCode: res.data.countryCode === null || res.data.countryCode === "" ? "USA +1" : res.data.countryCode,
                    defaultfirstName: res.data.firstName === null ? "" : res.data.firstName,
                    defaultlastName: res.data.lastName === null ? "" : res.data.lastName,
                    defaultemail: res.data.email === null ? "" : res.data.email,
                    defaultphone: res.data.phone === null ? "" : res.data.phone,
                    defaultcountryCode: res.data.countryCode === null || res.data.countryCode === "" ? "USA +1" : res.data.countryCode,
                    isAction: false
                }, () => {
                    this.setState({
                        allowEmailUpdateRequest: this.validate(true),
                        firstNameEmpty: false,
                        lastNameEmpty: false,
                        phoneNumberEmpty: false,
                        countrycodeempty: false,
                        firstnameregex: false,
                        lastnameregex: false,
                        phoneregex: false
                    });
                });
                this.updatePhonoToolTip(res.data.phone);
                if(res.data.thirdPartyUser && res.data.thirdPartyUser.psswdStatus.toString() === 'N') {
                    let thirdPartyName = 'Google';
                    if(res.data.thirdPartyUser.source === 'GitHub') {
                        thirdPartyName = res.data.thirdPartyUser.source;
                    }
                    this.setState({
                        isthirdpartylogin: true,
                        thirdPartyName: thirdPartyName
                    });
                }
            }
            else {
                this.setState({
                    message: res.message,
                    isAction: false
                });
            }
        }).catch(err => {
            this.setState({
                message: "Error while fetching details, try again!",
                isAction: false
            });
        });
        this.fetchUserSecurityInfo();
        this.fetchActiveEmailTransfer();
    }

    processEmailTransfer = () => {
        let state = this.props.history.location.state;
        if(!state || (!state.fromLogin && !state.from2fa)) {
            console.debug("Invalid flow to process email transfer with ETX token being set, clearing ETX token ...");
            loginService.deleteCookie(EMAIL_TRANSFER_TOKEN, "/api");
            return;
        }
        console.debug("processing email transfer ...");
        this.setState({
            isEmailTransferAction: true
        });
        userService.processEmailTransfer(this.state.userId).then(resp => {
            let data = resp?.data;
            if(data?.ok && data?.emailTransfer) {
                loginService.deleteCookie(EMAIL_TRANSFER_TOKEN, "/api");
                userService.getUser().then(resp => {
                    if(resp?.data) {
                        loginService.setUserLocal(resp, true);
                        this.setState({
                            firstName: resp.data.firstName,
                            lastName: resp.data.lastName,
                            email: resp.data.email,
                            phone: resp.data.phone,
                            countryCode: resp.data.countryCode,
                            defaultfirstName: resp.data.firstName,
                            defaultlastName: resp.data.lastName,
                            defaultemail: resp.data.email,
                            defaultphone: resp.data.phone,
                            defaultcountryCode: resp.data.countryCode,
                            pendingEmailTransfer: null,
                            message: "Your email address has been verified and updated to <b>" + data.emailTransfer.new_email + "</b>. Contact <a href=\"https://www.idrivecompute.com/support.htm\" target=\"blank\" rel=\"noopener noreferrer\">support</a> if you have not made this change.",
                            msgType: "success",
                            isEmailTransferAction: false
                        });
                    }
                    else {
                        this.setState({
                            message: resp.message,
                            isEmailTransferAction: false
                        });
                    }
                }).catch(error => {
                    console.error(error);
                    this.setState({
                        message: "Error while trying to get details, try again!",
                        isEmailTransferAction: false
                    });
                    return;
                });
            } else {
                console.error(data?.error);
                this.setState({
                    isEmailTransferAction: false,
                    message: data?.details ? String(data?.error).indexOf("token_not_found") === -1 ? data.details : "" : "Error while processing email update request.",
                    msgType: "error"
                });
            }
        }).catch(error => {
            loginService.deleteCookie(EMAIL_TRANSFER_TOKEN, "/api");
            if(error?.response?.data) {
                let data = error.response.data;
                console.log(data.error);
                let message = "";
                switch(data?.error) {
                    case "malformed_request":
                        message = "The email update request could not be processed since it has expired or is not valid. Please check and try again.";
                        break;
                    default:
                        break;
                }
                this.setState({
                    message: message,
                    msgType: "error",
                    isEmailTransferAction: false,
                });
            } else {
                console.log(error);
                this.setState({
                    message: "Error occurred while processing email update request. Please try again.",
                    msgType: "error",
                    isEmailTransferAction: false,
                });
            }
        });
    };

    fetchActiveEmailTransfer = () => {
        this.setState({
            isAction: true,
        });
        userService.fetchActiveEmailTransfer(this.state.userId).then(resp => {
            let data = resp.data;
            if(data?.ok) {
                // console.debug("Successfully fetched active email transfer requests.");
                this.setState({
                    pendingEmailTransfer: data?.emailTransfers.length === 0 ? null : data.emailTransfers[0],
                    isAction: false
                });
            } else {
                console.error(data?.error);
                this.setState({
                    message: data?.details ? data.details : "Error while fetching active email update request details.",
                    msgType: "error",
                    isAction: false
                });
            }
        }).catch(error => {
            console.error(error);
            if(error?.response?.data) {
                let data = error.response.data;
                if(data?.error && String(data.error).startsWith("field_taken")) {
                    this.setState({
                        message: "The email address requested is no longer available. Please try again.",
                        msgType: "error",
                        isAction: false
                    });
                    return;
                }
            }
            this.setState({
                message: "Error while fetching active email update request details.",
                msgType: "error",
                isAction: false
            });
        });
    };

    fetchUserSecurityInfo = () => {
        userService.getUserInfo().then(resp => {
            let info = resp.data.body;
            if(info?.auth_type === 3) {
                this.setState({
                    isTotpEnabled: true
                });
            }
        });
    };

    requestEmailTransfer = () => {
        this.validateUpdatedEmail();
    };

    checkPhoneRegex = (val) => {
        if(val.length >= 7) {
            $('#min_sev').addClass("success");
        } else {
            $('#min_sev').removeClass("success");
        }

        if(val.length > 0 && val.length <= 20) {

            $('#max_twe').addClass("success");
        } else {
            $('#max_twe').removeClass("success");
        }

        const phoneNumRegex = new RegExp("^[xX0-9-+()]+$");
        if(phoneNumRegex.test(val)) {

            $('#no_spe').addClass("success");
        } else {
            $('#no_spe').removeClass("success");
        }
    };
    checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            console.log(resp);
            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Error while getting user subscription details"

                });
                return;
            }
            if(resp.error) {
                this.setState({
                    isAction: false,
                    isUserSubscribed: false
                });
            }
            else {
                this.setState({
                    isUserSubscribed: true
                });

            }

        });
    };

    openPhoneVerifyPopup = () => {
        this.setState({
            otp: "",
            isPhoneVerifyPopup: true,
            message: "",
            msgType: ""
        }, () => {
            this.toggleVerifyButton();
        });
        $('body').addClass("no_scroll");
    };

    closePhoneVerifyPopup = () => {
        this.setState({
            isPhoneVerifyPopup: false,
            isAction: false
        });
        $('body').removeClass("no_scroll");
    };

    verifyOtp = () => {
        this.setState({
            otpempty: false,
            otpErr: false
        });
        if(this.state.otp.trim() == "") {
            this.setState({
                otpempty: true
            });
            this.otpInput.current.focus();
            return;
        }

        if(!Validate("otp", this.state.otp.trim()) || this.state.otp.trim().length < 6) {
            this.setState({
                otpErr: true
            });
            this.otpInput.current.focus();
            return;
        }

        this.setState({
            otpempty: false,
            otpErr: false
        });

        this.updateUserDetails();
    };
    onRecaptchaChange = (event) => {
        if(this.state.showSetPswdPopup) {
            $(".resetPswd_popup").addClass("active");
        } else if(this.state.isEmailUpdatePopupActive) {
            this.submitEmailUpdateRequest(event);
        } else if(this.state.isResendEmailUpdateEmailActive) {
            this.resendEmailUpdateEmail(event);
        } else {
            if(this.state.isResend) {
                this.sendOtp("resend", event);
            } else {
                this.sendOtp("send", event);
            }
        }
    };

    sendPhoneOtpByCaptcha() {
        if(this.recaptchaRef.current) {
            this.recaptchaRef.current.execute();
        }
    }

    reSendPhoneOtpByCaptcha() {
        this.setState({ isResend: true }, () => {
            if(this.recaptchaRef.current) {
                this.recaptchaRef.current.execute();
            }
        });

    }
    sendOtp = (type, event) => {
        if(type == "send") {
            this.setState({
                isAction: true,
            });
        }
        var cLabel = $("#countryCode option:selected").text();
        var c = cLabel.split('+');
        var cCode = '+' + c[1];
        this.setState({
            countryLabel: cCode.trim()
        }, () => {
            var otpDetails = {
                "email": this.state.email,
                "countryCode": this.state.countryLabel,
                "phone": this.state.phone
            };

            if(type == "resend") {
                $("#resend_btn").attr('disabled', 'disabled');
                $('#resend_btn').addClass("disabled");
                setTimeout(() => {
                    $("#resend_btn").removeAttr('disabled');
                    $('#resend_btn').removeClass("disabled");
                }, 10000);
            }

            ResourceService.sendProfileOtp(otpDetails, event).then(res => {
                //console.log(res)
                this.setState({
                    isAction: false,
                });
                clearInterval(this.timerId);
                if(res === undefined) {
                    if(type == "send") {
                        this.setState({
                            message: "Phone number could not be verified. Enter a valid phone number and try again.",
                            msgType: 'error'
                        });
                        this.phoneNumberFocus.current.focus();
                        if(this.recaptchaRef.current) {
                            this.recaptchaRef.current.reset();
                        }
                    } else {
                        //if error occured during resend
                    }
                } else {
                    clearInterval(this.timerId);
                    if(this.recaptchaRef.current) {
                        this.recaptchaRef.current.reset();
                    }
                    this.startTimer();
                    if(type == "resend") {
                        $('#verify_otp_msg').hide();
                        $('#otp').removeAttr('disabled');
                        $('#resend_msg').show();
                        setTimeout(() => {
                            $('#resend_msg').hide();
                        }, 3000);
                    } else {
                        this.openPhoneVerifyPopup();
                    }
                    this.otpInput.current.focus();
                }
            });
        });

    };

    startTimer() {
        //var mindisp = 0;
        //var secdis = 0;
        $("#otp_timer").html("Your verification code will expire in <b> 05:00</b> Minutes");
        var countdown = 5 * 60 * 1000;
        //var timerId ;
        //clearInterval(timerId);
        this.timerId = setInterval(() => {
            countdown -= 1000;
            var min = Math.floor(countdown / (60 * 1000));
            //var sec = Math.floor(countdown - (min * 60 * 1000));  // wrong
            var sec = Math.floor((countdown - (min * 60 * 1000)) / 1000);
            if(min == 0 && sec == 0) {
                clearInterval(this.timerId);

                $('#otp_timer').html('The verification code has expired. Click "Resend OTP" to receive new code.');
                this.setState({
                    otp: ""
                }, () => {
                    $('#otp').attr("disabled", "disabled");
                    this.toggleVerifyButton();
                });
            } else {
                this.mindisp = min;
                this.secdis = sec;
                if(min < 10)
                    this.mindisp = "0" + min;
                if(sec < 10)
                    this.secdis = "0" + sec;
                if(min == 0) {
                    $("#otp_timer").html("Your verification code will expire in <b>" + this.mindisp + ":" + this.secdis + "</b> Seconds");
                } else {
                    $("#otp_timer").html("Your verification code will expire in <b>" + this.mindisp + ":" + this.secdis + "</b> Minutes");
                }
            }

        }, 1000);

    }


    toggleVerifyButton() {
        $('#resend_msg').hide();
        //$('#otp').removeAttr("disabled")
        if(this.state.otp.length < 6) {
            $('#verify_btn').attr("disabled", "disabled");
            $('#verify_btn').addClass("disabled");
        } else {
            $('#verify_btn').removeAttr("disabled");
            $('#verify_btn').removeClass("disabled");
        }
    }

    // generateToken = async (email) => {
    //     try{
    //         let resp = await Axios.post(API_HOST+"/user/generatetoken/"+email,{},axiosRequestWithAuth) ;
    //         return resp.data ;
    //     }
    //     catch(err){
    //         console.log(err)
    //     }
    // }

    enableForgetPassword() {
        $("body").removeClass("popup_no_scroll");
        $(".resetPswd_popup").removeClass("active");
        this.setState({
            isAction: true
        });
        if(this.state.isthirdpartylogin) {
            userService.resetpassword().then(resp => {
                if(resp == false) {
                    this.setState({
                        message: "An error occured. Please try again.",
                        msgType: 'error',
                        isAction: false
                    });
                    if(this.recaptchaRef.current) {
                        this.recaptchaRef.current.reset();
                    }
                    return;
                }
                else {
                    if(resp.data.body.error) {
                        this.setState({
                            message: "Error while sending reset password link",
                            isAction: false
                        });
                        return;
                    }
                    this.setState({
                        message: "An email has been sent with instructions to set the password.",
                        msgType: "",
                        isAction: false
                    });
                    return;
                }
            });
            //this.openForgotPasswordWindow();
        }
    }

    openForgotPasswordWindow() {
        let email = localStorage.getItem("email");
        let href = window.location.protocol + "//" + window.location.host + "/app/forgot-password?username=" + email;
        window.open(href, '_blank');
    }

    hideSetPasswordPopup() {
        $(".resetPswd_popup").removeClass("active");
        $("body").removeClass("popup_no_scroll");
    }

    enablePopupPassword = () => {
        if(this.state.isthirdpartylogin) {
            // this.openForgotPasswordWindow() ;
            $("body").addClass("popup_no_scroll");
            $(".resetPswd_popup").addClass("active");
            // userService.generateToken(email).then( resp => {
            //     if(!resp){
            //         this.setState({
            //             message : "Error while fetching details, try again!",
            //             msgType:"error"
            //         });
            //     }
            //     else{
            //         let token = resp;
            //         let href = window.location.protocol + "//" + window.location.host + "/app/forgot-password?username="+ email ;
            //         //let href = window.location.protocol + "//" + window.location.host + "/app/update-password/" + email + "/" + token+"?type=fromThirdPartyLogin";
            //         window.open(href, '_blank');
            //     }

            //    }, function(error) {
            //     this.setState({
            //         message : "Error while fetching details, try again!",
            //         msgType:"error"
            //     });
            //    });
        }
        else {
            this.setState({
                isChangePsswdPopup: true,
                changePsswdForm: {
                    currentPsswd: '',
                    newPsswd: '',
                    confirmPsswd: ''
                },
                psswdStrength: '',
                message: "",
                curpswderror: false,
                confirmpswderror: false,
                pswdregex: false,
                pswdempty: false,
                curpswdempty: false,
                ispswdsame: false,
                getcurpswd: false,
                getnewpswd: false,
                getConfmPass: false
            });
            $("body").addClass("popup_no_scroll");
            $('#upperCaseLi').removeClass("success");
            $('#lowerCaseLi').removeClass("success");
            $('#numericLi').removeClass("success");
            $('#specCharLi').removeClass("success");
            $('#eightCharLi').removeClass("success");
            setTimeout(() => {
                this.currentPsswdFocus.current.focus();

            }, 100);
        }

    };
    enableCancelPassword = () => {
        this.setState({
            isCancelMyAccount: true,
            curpswdempty: false,
            cancelpswdempty: false,
            cancelphoneempty: false,
            cancelmailempty: false,
            cancelreasonempty: false,
            cancelreason: "",
            cancelcomments: "",
            cancelpassword: "",
            cancelphone: "",
            cancelemail: "",

        });
        setTimeout(() => {
            this.cancelPswdFocus.current.focus();
        }, 100);

    };
    showCurPswd = (param) => {
        if(param === "current") {
            this.setState({
                getcurpswd: !this.state.getcurpswd
            });
        }
        else if(param === "new") {
            this.setState({
                getnewpswd: !this.state.getnewpswd
            });
        }
        else {
            this.setState({
                getConfmPass: !this.state.getConfmPass
            });
        }
    };

    handleInputs = (event) => {
        let name = event.target.name;
        let val = event.target.value;

        this.setState({
            [name]: val
        });

        this.setState({
            invalidemail: false,
            invalidpassword: false,
            invalidphone: false,
            emailerror: false,
            countrycodeempty: false,
            issaveenable: true
        });

        if(name === "countryCode") {
            if(val.length > 0) {
                this.setState({
                    countrycodeempty: false,
                });
            }
        }

        if(name === "firstName") {
            if(val.length > 0) {
                this.setState({
                    firstNameEmpty: false,
                    firstnameregex: false
                });
            }
        }
        if(name === "lastName") {
            if(val.length > 0) {
                this.setState({
                    lastNameEmpty: false,
                    lastnameregex: false
                });
            }
        }
        if(name === "email") {
            if(val.length > 0) {
                if(this.state.isthirdpartylogin) {
                    this.setState({
                        emailEmpty: false,
                        emailregex: false,
                        showSetPswdPopup: true
                    });
                }
                else {
                    this.setState({
                        emailEmpty: false,
                        emailregex: false,
                    });
                }
            }
        }
        if(name === "phone") {
            if(val.length > 0) {
                this.setState({
                    phoneNumberEmpty: false,
                    phoneregex: false
                });
                if(val.length >= 7) {
                    $('#min_sev').addClass("success");
                } else {
                    $('#min_sev').removeClass("success");
                }

                if(val.length > 0 && val.length <= 20) {
                    $('#max_twe').addClass("success");
                } else {
                    $('#max_twe').removeClass("success");
                }

                const phoneNumRegex = new RegExp("^[xX0-9-+()]+$");
                if(phoneNumRegex.test(val)) {
                    $('#no_spe').addClass("success");
                } else {
                    $('#no_spe').removeClass("success");
                }
            }
            else {
                $('#min_sev').removeClass("success");
                $('#max_twe').removeClass("success");
                $('#no_spe').removeClass("success");

            }
            // this.updatePhonoToolTip(val);        
        }
        if(name === "cancelreason") {
            if(val.length > 0) {
                this.setState({
                    cancelreasonempty: false
                });
            }
            if(val.toLowerCase() !== "others") {
                this.setState({
                    cancelcommentsempty: false,
                });
            }
        }
        if(name === "cancelpassword") {
            if(val.length > 0) {
                this.setState({
                    cancelpswdempty: false

                });
            }
        }
        if(name === "cancelphone") {
            if(val.length > 0) {
                this.setState({
                    cancelphoneempty: false
                });
                if(val.length >= 7) {
                    this.setState({
                        sevenChars: true
                    });

                } else {
                    this.setState({
                        sevenChars: false
                    });
                }

                if(val.length > 0 && val.length <= 20) {
                    this.setState({
                        twentyChars: true
                    });
                } else {
                    this.setState({
                        twentyChars: false
                    });
                }

                const phoneNumRegex = new RegExp("^[xX0-9-+()]+$");
                if(phoneNumRegex.test(val)) {
                    this.setState({
                        npSpecial: true
                    });
                } else {
                    this.setState({
                        npSpecial: false
                    });
                }
            }
            else {
                this.setState({
                    npSpecial: false,
                    sevenChars: false,
                    twentyChars: false
                });

            }

        }

        if(name === "otp") {
            if(val.length > 0) {
                this.setState({
                    otpempty: false
                });
            }
        }
    };

    updatePhonoToolTip(val) {
        if(val != null) {
            if(val.length >= 7) {
                $('#min_sev').addClass("success");
            } else {
                $('#min_sev').removeClass("success");
            }

            if(val.length > 0 && val.length <= 20) {
                $('#max_twe').addClass("success");
            } else {
                $('#max_twe').removeClass("success");
            }
            const phoneNumRegex = new RegExp("^[xX0-9-+()]$");
            if(phoneNumRegex.test(val)) {
                $('#no_spe').addClass("success");
            } else {
                $('#no_spe').removeClass("success");
            }
        } else {
            $('#min_sev').removeClass("success");
            $('#max_twe').removeClass("success");
            $('#no_spe').removeClass("success");
        }

    }

    hidePsswd = (event, key) => {
        this.setState({ [key]: !this.state[key] });
    };

    ChangePsswdHandler = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        let form = this.state.changePsswdForm;
        form[name] = val;
        this.setState({ changePsswdForm: form });
        if(name === 'currentPsswd') {

            if(val.length > 0) {
                this.setState({

                    curpswdempty: false, curpswderror: false
                });
            }
            else {
                this.setState({
                    curpswdempty: true, curpswderror: false
                });
            }

        }
        else if(name === 'newPsswd') {
            this.setState({
                pswdregex: false,
                ispswdsame: false
            });
            if(val.length > 0) {
                this.setState({
                    psswdStrength: getPsswdStrength(val),
                    pswdregex: false,
                    pswdempty: false,
                    ispswdsame: false
                });
            }
            else {
                this.setState({
                    pswdempty: true
                });
            }

            var upCasePatt = new RegExp("[A-Z]");
            if(upCasePatt.test(val)) {
                $('#upperCaseLi').addClass("success");
            } else {
                $('#upperCaseLi').removeClass("success");
            }
            var lowCasePatt = new RegExp("[a-z]");
            if(lowCasePatt.test(val)) {
                $('#lowerCaseLi').addClass("success");
            } else {
                $('#lowerCaseLi').removeClass("success");
            }
            var numericPatt = new RegExp("[0-9]");
            if(numericPatt.test(val)) {
                $('#numericLi').addClass("success");
            } else {
                $('#numericLi').removeClass("success");
            }
            var specCharPat = /[`!@#$%^&*()_+\-={};':"|,.<>\/?~]/;
            if(specCharPat.test(val)) {
                $('#specCharLi').addClass("success");
            } else {
                $('#specCharLi').removeClass("success");
            }
            if(val.length >= 8) {
                $('#eightCharLi').addClass("success");
            } else {
                $('#eightCharLi').removeClass("success");
            }
        }
        else if(name === 'confirmPsswd') {
            if(val.length > 0) {
                this.setState({
                    confirmpswderror: false

                });
            }
            else {
                this.setState({
                    confirmpswderror: true
                });
            }

        }
    };

    changePsswdFormSubmit = (event) => {
        event.preventDefault();

        const data = {
            curpswd: this.state.changePsswdForm.currentPsswd,
            newpswd: this.state.changePsswdForm.newPsswd

        };
        let conpswd = this.state.changePsswdForm.confirmPsswd;
        if(data.curpswd.length > 0) {
            if(data.newpswd.length <= 0) {
                this.setState({
                    pswdregex: false,
                    pswdempty: true,
                    isPaswdUpdateDisable: false
                });
                this.changeNewPassword.current.focus();
                return;
            }
            if(data.curpswd === data.newpswd) {
                this.setState({
                    ispswdsame: true,
                    pswdregex: false
                });
                this.changeNewPassword.current.focus();
                return;
            }
            if(getPsswdStrength(data.newpswd) === "Strong") {

                if(data.newpswd === conpswd) {
                    this.setState({
                        isAction: true,
                        isPaswdUpdateDisable: true
                    });
                    userService.updatePassword(data).then(resp => {
                        if(resp === false) {
                            this.setState({
                                message: "Error while updating password, try again!",
                                msgType: "error",
                                isChangePsswdPopup: false,
                                isAction: false,
                                isPaswdUpdateDisable: false
                            });
                            return;
                        }
                        if(!(resp.data.error)) {
                            this.setState({
                                message: "Password Updated Successfully",
                                isChangePsswdPopup: false,
                                isAction: false,
                                isPaswdUpdateDisable: false
                            }, () => {
                                this.setState({
                                    isthirdpartylogin: false
                                });
                            });

                        }
                        else {
                            if(resp.data.message.indexOf("Current") !== -1) {
                                this.setState({
                                    curpswderror: true,
                                    curpswdempty: false,
                                    isAction: false,
                                    isPaswdUpdateDisable: false
                                });
                                this.currentPsswdFocus.current.focus();
                            }
                        }
                    });
                }
                else {
                    this.setState({
                        confirmpswderror: true,
                        isPaswdUpdateDisable: false
                    });
                    this.changeConfirmPassword.current.focus();
                }

            }
            else {
                this.setState({
                    pswdregex: true,
                    ispswdsame: false,
                    isPaswdUpdateDisable: false
                });
                this.changeNewPassword.current.focus();
            }

        }
        else {
            this.setState({
                curpswdempty: true,
                isPaswdUpdateDisable: false
            });
            this.currentPsswdFocus.current.focus();
        }

    };

    saveChanges = () => {
        if(this.validate()) {
            if(this.state.defaultphone != this.state.phone || this.state.defaultcountryCode != this.state.countryCode) {
                this.setState({ isResend: false }, () => this.recaptchaRef.current.execute());
                //this.sendOtp("send");
            } else {
                this.updateUserDetails();
            }
        }
    };

    updateUserDetails() {
        if(this.state.showSetPswdPopup) {
            $(".resetPswd_popup").addClass("active");
        }
        else {
            this.setState({
                isAction: true,
                showVerifyLoader: true
            });
            const data = {
                firstName: this.state.firstName.trim(),
                lastName: this.state.lastName.trim(),
                email: this.state.email.trim(),
                phone: this.state.phone.trim(),
                countryCode: this.state.countryCode,
                otp: this.state.otp.trim()
            };

            userService.updateUserDetails(data).then(res => {
                this.setState({
                    showVerifyLoader: false
                });
                if(res === false) {
                    if(this.state.isPhoneVerifyPopup) {
                        $('#verify_otp_msg').show();
                        setTimeout(() => {
                            $('#verify_otp_msg').hide();
                        }, 5000);
                        this.setState({
                            otp: ""
                        }, () => {
                            this.toggleVerifyButton();
                        });
                        this.otpInput.current.focus();
                    } else {
                        this.setState({
                            message: "Error while trying to update details, try again!",
                            isAction: false
                        });
                    }
                    return;
                }
                if(res.data.error) {
                    if(String(res.data.message).startsWith("Name Error")) {
                        this.setState({
                            message: "First name or last name can contain a-z, A-Z, space and maximum of 20 characters",
                            msgType: "error",
                            isAction: false
                        });
                        return;
                    }
                    if(String(res.data.message).startsWith("Email already exists")) {
                        this.setState({
                            emailerror: true,
                            isAction: false
                        });
                        return;
                    }
                    this.setState({
                        emailregex: true,
                        isAction: false
                    });
                    return;
                }
                if(!(res.data.error)) {
                    localStorage.setItem("email", this.state.email);
                    this.setState({
                        otp: ""
                    });
                    this.closePhoneVerifyPopup();
                    this.props.updateHeader();
                    if(this.state.defaultemail === this.state.email) {
                        const logUpdate = {
                            "userId": localStorage.getItem("userId"),
                            "name": "Profile Update",
                            "operation": "Profile Update",
                            "details": "Profile details updated sucessfully"
                        };
                        AuditLog.storeAuditLogs(logUpdate, "web").then((resp) => {
                            if(resp === false);
                        });
                    }
                    else {
                        const emailUpdate = {
                            "userId": localStorage.getItem("userId"),
                            "name": "Profile Update",
                            "operation": "Profile Update",
                            "details": "Email updated sucessfully from " + this.state.defaultemail + " to " + this.state.email
                        };
                        AuditLog.storeAuditLogs(emailUpdate, "web").then((resp) => {
                            if(resp === false);
                        });
                    }

                    userService.getUser().then(res => {
                        if(res?.data) {
                            loginService.setUserLocal(res, true);
                            this.setState({
                                firstName: res.data.firstName,
                                lastName: res.data.lastName,
                                email: res.data.email,
                                phone: res.data.phone,
                                countryCode: res.data.countryCode,
                                defaultfirstName: res.data.firstName,
                                defaultlastName: res.data.lastName,
                                defaultemail: res.data.email,
                                defaultphone: res.data.phone,
                                defaultcountryCode: res.data.countryCode,
                                isAction: false

                            }, () => {
                                this.setState({
                                    allowEmailUpdateRequest: this.validate(true)
                                });
                            });
                        }
                        else {
                            this.setState({
                                message: res.message,
                                isAction: false
                            });
                        }
                    }).catch(err => {
                        this.setState({
                            message: "Error while trying to get details, try again!",
                            isAction: false
                        });
                        return;
                    });
                    this.setState({
                        message: res.data.message,
                        isAction: false,
                        msgType: 'success'
                    });
                }
                else {

                    this.setState({
                        emailerror: true,
                        isAction: false
                    });
                }
            });
        }

    }

    keepMyAcccount = () => {
        $(".cancel_acc_step1").removeClass("hide");
        $(".cancel_acc_step1").removeClass("show");
        $(".cancel_acc_step2").removeClass("show");
        $(".cancel_acc_step2").removeClass("hide");
        $("body").removeClass("popup_no_scroll");
        this.setState({
            isCancelMyAccount: false
        });
    };

    cancelSubuserAcccont = () => {
        const data = {
            curpswd: this.state.cancelpassword,
            phone: this.state.cancelphone,
            email: this.state.email,
            reason: this.state.cancelreason,
            comments: this.state.cancelcomments,
            date: new Date()
        };

        if(!this.state.isthirdpartylogin && data.curpswd.length <= 0) {

            this.setState({
                cancelpswdempty: true
            });
            this.cancelPswdFocus.current.focus();
        }
        else if(data.phone.length <= 0) {

            this.setState({
                cancelphoneempty: true
            });
            this.cancelPhoneFocus.current.focus();
        }

        else if(data.reason.length <= 0) {

            this.setState({
                cancelreasonempty: true
            });
            this.cancelReasonFocus.current.focus();
        }
        else if(data.reason.toLowerCase() === "others" && (data.comments === null || !data?.comments)) {
            this.setState({
                cancelcommentsempty: true,
            });
            this.cancelCommentsFocus.current.focus();
        }
        else {
            if(!(Validate("phoneNumber", data.phone))) {
                this.setState({
                    invalidphone: true
                });
                this.cancelPhoneFocus.current.focus();
                return false;
            }

            else {
                this.setState({
                    isAction: true,
                    isCancelMyAccount: false
                });
                userService.cancelAccnt(data).then(resp => {
                    if(resp !== false) {
                        if(!(resp.data.error)) {

                            if(this.clearStorage()) {
                                this.setState({
                                    redirect: true
                                });
                            }


                        }
                        else {
                            if(resp.data.message.indexOf("Password") != -1) {
                                this.setState({
                                    invalidpassword: true,
                                    isCancelMyAccount: true,
                                    isAction: false
                                });
                            } else if(resp.data.message.indexOf("Transaction") != -1) {
                                this.setState({
                                    message: resp.data.message,
                                    isCancelMyAccount: false,
                                    isAction: false
                                });
                            }
                        }
                    }
                    else {
                        this.setState({
                            message: "Error while cancelling account, try again",
                            isAction: false
                        });
                    }

                });


            }
        }

    };

    cancelAccountSecondPopup = () => {
        $(".cancel_acc_step2").removeClass("show");
        $(".cancel_acc_step1").removeClass("hide");
        $(".cancel_acc_step2").addClass("hide");
        $(".cancel_acc_step1").addClass("show");
        $("body").addClass("popup_no_scroll");
        setTimeout(() => {
            this.cancelPswdFocus.current.focus();
        }, 100);
    };

    cancelAccountFirstPopup = () => {


        if(this.state.roleId === "1") {
            this.setState({
                isCancelMyAccount: true,
                curpswdempty: false,
                cancelpswdempty: false,
                cancelphoneempty: false,
                cancelmailempty: false,
                cancelreasonempty: false,
                cancelreason: "",
                cancelcomments: "",
                cancelpassword: "",
                cancelphone: "",
                cancelemail: "",

            });
            setTimeout(() => {
                this.cancelPswdFocus.current.focus();
            }, 100);
            $("body").addClass("popup_no_scroll");

            $(".cancel_acc_step1").addClass("show");
            $(".cancel_acc_step2").addClass("hide");

        }
        else {
            if(localStorage.getItem("status") === 'S') {
                this.setState({
                    message: "Please update card details to lift suspension of account before cancellation",
                    msgType: "error",
                });
                return;
            }
            this.setState({
                isAction: true
            });
            axiosInstance.get(API_HOST + "/resource/" + this.state.userId + "/fetch", axiosRequestWithAuth).then((resp) => {
                this.setState({
                    isCancelMyAccount: true,
                    totalAmount: resp.data.amount,
                    isAction: false,
                });
                $(".cancel_acc_step1").addClass("hide");
                $(".cancel_acc_step2").addClass("show");

                this.setState({
                    isCancelMyAccount: true,
                    curpswdempty: false,
                    cancelpswdempty: false,
                    cancelphoneempty: false,
                    cancelmailempty: false,
                    cancelreasonempty: false,
                    cancelreason: "",
                    cancelcomments: "",
                    cancelpassword: "",
                    cancelphone: "",
                    cancelemail: ""

                });
                setTimeout(() => {
                    this.cancelPswdFocus.current.focus();
                }, 100);
                $("body").addClass("popup_no_scroll");


            }).catch((error) => {
                console.log(error);
                this.setState({
                    isCancelMyAccount: false,
                    isAction: false,
                    message: "Error while fectching, try again"
                });
            });
        }

    };

    validate(skipDefaultComparison) {
        if(this.state.defaultfirstName === this.state.firstName && this.state.defaultlastName === this.state.lastName && this.state.defaultcountryCode === this.state.countryCode
            && this.state.defaultphone === this.state.phone) {
            if(!skipDefaultComparison) {
                this.setState({
                    message: "Make changes to update the profile"
                });
                return false;
            }
        }

        if(this.state.firstName.trim().length <= 0) {
            this.setState({
                firstNameEmpty: true
            });
            this.firstNameFocus.current.focus();
            return false;
        }
        else if(this.state.lastName.trim().length <= 0) {
            this.setState({
                lastNameEmpty: true
            });
            this.lastNameFocus.current.focus();
            return false;
        }
        else if(this.state.email.trim().length <= 0) {
            this.setState({
                emailEmpty: true
            });
            this.emailFocus.current.focus();
            return false;
        }
        else if(this.state.phone.trim().length <= 0) {
            this.setState({
                phoneNumberEmpty: true
            });
            this.phoneNumberFocus.current.focus();
            return false;
        }
        else if(this.state.countryCode.length <= 0) {
            this.setState({
                countrycodeempty: true
            });

            return false;
        }
        else {

            if(!(Validate("firstName", this.state.firstName))) {

                this.setState({
                    firstnameregex: true
                });
                this.firstNameFocus.current.focus();
                return false;
            }
            else if(!(Validate("lastName", this.state.lastName))) {
                this.setState({
                    lastnameregex: true
                });
                this.lastNameFocus.current.focus();
                return false;
            }
            else if(!(Validate("email", this.state.email))) {
                this.setState({
                    emailregex: true
                });
                this.emailFocus.current.focus();
                return false;
            }
            else if(!(Validate("phoneNumber", this.state.phone))) {
                this.setState({
                    phoneregex: true
                });
                this.phoneNumberFocus.current.focus();
                return false;
            }
            else {
                return true;
            }
        }
    }

    emailUpdatePopupFocusHandler = (event) => {
        if(!document.getElementById("emailUpdatePopup").contains(event.target) && this.state.isEmailUpdatePopupActive) {
            this.closeEmailUpdatePopup(event);
        }
    };

    showEmailUpdatePopup = (event) => {
        if(!this.state.allowEmailUpdateRequest) return;
        this.setState({
            updatedEmail: "",
            currPwd: "",
            isPswdVisible: false,
            isEmailUpdatePopupActive: true,
            emailempty: false,
            emailerror: false,
            emailregex: false,
            emptyPwd_eu: false,
            invalidPwd_eu: false
        }, () => {
            this.emailFocus.current.focus();
        });
        $("body").addClass("popup_no_scroll");
        let submitBtn = document.getElementById("submitEmailUpdateBtn");
        submitBtn.innerText = "Change";
        submitBtn.classList.remove("btnLoader");
    };

    closeEmailUpdatePopup = (event) => {
        // console.debug("Closing email update popup ...");
        this.setState({
            isEmailUpdatePopupActive: false,
            emailempty: false,
            emailerror: false,
            emailregex: false,
            emptyPwd_eu: false,
            invalidPwd_eu: false
        });
        this.closePopupMsg_eu();
        $("body").removeClass("popup_no_scroll");
        let submitBtn = document.getElementById("submitEmailUpdateBtn");
        submitBtn.innerText = "Change";
        submitBtn.classList.remove("btnLoader");
    };

    validateUpdatedEmail = () => {
        if(this.state.updatedEmail.trim().length <= 0) {
            this.setState({
                emailempty: true
            });
            return false;
        } else if(!Validate("email", this.state.updatedEmail)) {
            this.setState({
                emailregex: true
            });
            return false;
        } else if(this.state.updatedEmail.trim() === this.state.defaultemail.trim()) {
            this.setState({
                emailerror: true
            });
            return false;
        }
        return true;
    };

    validateEmailUpdatePwd = (event) => {
        if(this.state.currPwd.trim().length === 0) {
            this.setState({
                emptyPwd_eu: true
            });
            return false;
        }
        return true;
    };

    emailUpdateInputHandler = (event) => {
        this.setState({
            updatedEmail: event.target.value,
            emailempty: false,
            emailerror: false,
            emailregex: false,
        });
    };

    emailUpdatePwdInputHandler = (event) => {
        this.setState({
            currPwd: event.target.value,
            emptyPwd_eu: false,
            invalidPwd_eu: false
        });
    };

    emailUpdateInputReturnKeyHandler = (event) => {
        if(event.keyCode === 13) this.validateAndSubmitEmailUpdateRequest(event);
    };

    togglePswdVisibility = (event) => {
        this.setState(prevState => {
            return {
                ...prevState,
                isPswdVisible: !prevState.isPswdVisible
            };
        });
    };

    shouldDisableTooltip = (elementId) => {
        let e = document.getElementById(elementId);
        if(typeof e !== 'undefined' && e !== null)
            return e.offsetWidth >= e.scrollWidth;
    };

    closePopupMsg_eu = () => {
        this.setState({
            showPopupMsg_eu: false,
        });
        clearTimeout(sessionStorage.popupMsgTimeout_eu);
    };

    setPopupMsg_eu = (msg, type) => {
        if(String(msg).trim() !== "") {
            clearTimeout(sessionStorage.popupMsgTimeout_eu);
            this.setState({
                popupMsg_eu: msg,
                popupMsgType_eu: type,
                showPopupMsg_eu: true
            });
            sessionStorage.popupMsgTimeout_eu = setTimeout(() => {
                this.closePopupMsg_eu();
            }, 5000);
        }
    };

    validateAndSubmitEmailUpdateRequest = (event) => {
        event.preventDefault();
        let submitBtn = document.getElementById("submitEmailUpdateBtn");
        if(submitBtn.classList.contains("btnLoader")) return;
        submitBtn.classList.add("btnLoader");
        submitBtn.innerText = "";
        this.setState({
            isAction: true
        });
        if(!this.validateUpdatedEmail()) {
            this.setState({
                isAction: false
            });
            submitBtn.innerText = "Change";
            submitBtn.classList.remove("btnLoader");
            // this.setPopupMsg_eu(
            //     this.state.updatedEmail.trim().length === 0 ?
            //         "Email address cannot be empty. Please update and try again." :
            //         this.state.emailerror ?
            //             "Please make modification(s) to current email address and try again." :
            //             "Invalid email provided. Please update and try again.",
            //     "error");
            this.emailFocus.current.focus();
            return;
        } else if(!this.validateEmailUpdatePwd()) {
            this.setState({
                isAction: false
            });
            submitBtn.innerText = "Change";
            submitBtn.classList.remove("btnLoader");
            this.updateEmailPswdFocus.current.focus();
        } else {
            this.setState({
                isAction: false
            });
            submitBtn.innerText = "Change";
            submitBtn.classList.remove("btnLoader");
            this.recaptchaRef.current.execute();
        }
    };

    submitEmailUpdateRequest = (captchaToken) => {
        this.setState({
            isAction: true
        });
        if(this.recaptchaRef.current) {
            this.recaptchaRef.current.reset();
        }
        let submitBtn = document.getElementById("submitEmailUpdateBtn");
        submitBtn.classList.add("btnLoader");
        submitBtn.innerText = "";
        let emailTransferDto = {
            email: this.state.updatedEmail,
            password: this.state.currPwd
        };
        userService.requestEmailTransfer(this.state.userId, emailTransferDto, captchaToken).then(resp => {
            let data = resp?.data;
            if(data?.ok) {
                this.setState({
                    message: "An email has been sent to <b>" + this.state.updatedEmail + "</b>. Complete verification to update email address. <br /> You may need to check your spam folder or add support@idrivecompute.com to your contact list to make sure mails get delivered to your inbox.",
                    msgType: "success",
                    pendingEmailTransfer: data?.emailTransfer,
                    isEmailUpdatePopupActive: false,
                    isAction: false,
                });
            } else {
                console.error(data?.error);
                this.setState({
                    isAction: false
                });
                this.setPopupMsg_eu(
                    data?.details ? data.details : "Error occurred while submitting email update request.",
                    "error"
                );
            }
            this.closeEmailUpdatePopup();
        }).catch(error => {
            if(error?.response?.data) {
                let data = error.response.data;
                console.log(data.error);
                if(data?.error) {
                    if(String(data.error).startsWith("field_taken")) {
                        this.setPopupMsg_eu(
                            "Email address requested is already taken. Try with another.",
                            "error"
                        );
                        this.emailFocus.current.focus();
                    } else if(String(data.error).startsWith("invalid_parameter")) {
                        this.setState({
                            emailregex: true,
                        });
                        this.emailFocus.current.focus();
                    } else if(String(data.error).startsWith("invalid_credentials")) {
                        this.setState({
                            invalidPwd_eu: true
                        });
                        this.updateEmailPswdFocus.current.focus();
                    } else if(String(data.error).startsWith("exceeded_retries")) {
                        this.setState({
                            message: "You have exceeded the maximum number of retries for updating the registered email address. Try again after 24 hours or contact <a href=\"https://www.idrivecompute.com/support.htm\" target=\"blank\" rel=\"noopener noreferrer\">support</a>.",
                            msgType: "error",
                            isEmailUpdatePopupActive: false,
                            isAction: false,
                        });
                        this.closeEmailUpdatePopup();
                    } else {
                        this.setPopupMsg_eu(
                            data?.details ? data.details : "Error occurred while submitting email update request.",
                            "error"
                        );
                    }
                } else {
                    this.setPopupMsg_eu(
                        "Error occurred while submitting email update request.",
                        "error"
                    );
                }
            } else {
                console.log(error);
                this.setPopupMsg_eu(
                    "Error occurred while submitting email update request.",
                    "error"
                );
            }
            this.setState({
                isAction: false
            });
            submitBtn.innerText = "Change";
            submitBtn.classList.remove("btnLoader");
            $("body").removeClass("popup_no_scroll");
        });
    };

    resendEmailUpdateEmailHandler = (event) => {
        event.preventDefault();
        this.setState({
            isResendEmailUpdateEmailActive: true,
        }, () => {
            this.recaptchaRef.current.execute();
        });
    };

    resendEmailUpdateEmail = (captchaToken) => {
        this.setState({
            isAction: true,
            isResendEmailUpdateEmailActive: false
        });
        if(this.recaptchaRef.current) {
            this.recaptchaRef.current.reset();
        }
        userService.resendEmailTransferEmail(this.state.pendingEmailTransfer?.id, this.state.userId, captchaToken).then(resp => {
            let data = resp?.data;
            if(data?.ok) {
                this.setState({
                    message: "Verification email has been resent. <br />You may need to check your spam folder or add support@idrivecompute.com to your contact list to make sure mails get delivered to your inbox.",
                    msgType: "success",
                    isAction: false,
                });
            } else {
                console.error(data?.error);
                this.setState({
                    message: data?.details ? data.details : "Error while resending verification email for email update request.",
                    msgType: "error",
                    isAction: false
                });
            }
        }).catch(error => {
            console.error(error);
            this.setState({
                message: "Error occurred while resending verification email for email update request.",
                msgType: "error",
                isAction: false
            });
        });
    };

    cancelEmailUpdate = (event) => {
        event.preventDefault();
        this.setState({
            isAction: true,
        });
        userService.cancelEmailTransfer(this.state.pendingEmailTransfer?.id, this.state.userId).then(resp => {
            let data = resp?.data;
            if(data?.ok) {
                this.setState({
                    message: "Successfully cancelled email update request.",
                    msgType: "success",
                    pendingEmailTransfer: null,
                    isAction: false,
                });
            } else {
                console.error(data?.error);
                this.setState({
                    message: data?.details ? data.details : "Error while cancelling email update request.",
                    msgType: "error",
                    isAction: false
                });
            }
        }).catch(error => {
            console.error(error);
            this.setState({
                message: "Error occurred while cancelling email update request.",
                msgType: "error",
                isAction: false
            });
        });
        return;
    };

    render() {
        // console.debug("rendering again ...");
        const pswwdStyle = {
            background: 'url(/webapp/images/eye-icon.svg) no-repeat'
        };
        if(this.state.redirect) {
            return <Redirect to={ {
                pathname: "/login",
                state: { cancelled: "yes" }
            } }></Redirect>;
        }

        return (
            <React.Fragment>
                <div className="full_page_loader" style={ { display: this.state.isAction || this.state.isEmailTransferAction ? 'block' : 'none' } }>
                    <div className="loader_icon"></div>
                </div>
                <section className="accountModule_wrapper">
                    <div className="accModule_head_wrap">
                        <div className="settModule_head_lhs">
                            <h2>Profile Details</h2>
                            <p className="head_info">Update your account information to receive account-related notifications</p>
                        </div>
                    </div>
                    <div className="acc-impMsg" style={ { display: this.state.isthirdpartylogin ? "block" : "none" } }>
                        <p>You are currently using { this.state.thirdPartyName } Sign-in, which does not require a password.<br />For security reasons, features like updating the registered email address require setting up a password for your account. Once the password is updated, you can use  { this.state.thirdPartyName } Sign-in or your email address and password for logging in.</p>
                    </div>
                    <div className="acc-impMsg" style={ { display: this.state.isTotpEnabled && this.state.pendingEmailTransfer && this.state.showTotpEnabledMsg !== null ? "block" : "none" } }>
                        <p>
                            You have currently enabled TOTP two-factor authentication mechanism.<br />Please note than when the registered email address is updated for your account, the codes received for two-factor authentication will still continue to work. But the email address in the authenticator app would not be updated and has to be edited manually later.
                        </p>
                        <span className="close_icon" data-toggle="tooltip" data-for="closeTotpMsg" data-tip onClick={ () => this.setState({ showTotpEnabledMsg: false }) } />
                        <ReactTooltip id="closeTotpMsg" place='top' effect='solid'>Close</ReactTooltip>
                    </div>
                    <div className="field_sec_wrap">
                        <h3>Account Information</h3>
                        <div className="field_wrap">
                            <div className="common_txtBox_row">
                                <label>First Name</label>
                                <input type="text" autoComplete="off" ref={ this.firstNameFocus } maxLength="20" name="firstName" value={ this.state.firstName } onChange={ this.handleInputs } className="txtBox" onKeyDown={ (e) => this.detailEnterKey(e) } />
                                <span className="err_msg" style={ { display: this.state.firstNameEmpty ? 'inline-block' : 'none' } } >First Name cannot be blank</span>
                                <span className="err_msg" style={ { display: this.state.firstnameregex ? 'inline-block' : 'none' } } >First name can contain a-z, A-Z and space</span> </div>
                            <div className="common_txtBox_row">
                                <label>Last Name</label>
                                <input type="text" autoComplete="off" ref={ this.lastNameFocus } maxLength="20" name="lastName" value={ this.state.lastName } onChange={ this.handleInputs } className="txtBox" onKeyDown={ (e) => this.detailEnterKey(e) } />
                                <span className="err_msg" style={ { display: this.state.lastNameEmpty ? 'inline-block' : 'none' } } >Last Name cannot be blank</span>
                                <span className="err_msg" style={ { display: this.state.lastnameregex ? 'inline-block' : 'none' } } >Last name can contain a-z, A-Z and space</span> </div>
                        </div>
                        <div className="field_wrap">
                            <div className="common_txtBox_row updateEmail" style={ { display: this.state.isthirdpartylogin ? "none" : "block" } }>
                                <label>Email Address</label>
                                <div className="curEmailblk">
                                    <em id="currentEmailField" data-tip data-for="currentEmailField">{ this.state.defaultemail }</em>
                                    <ReactTooltip id="currentEmailField" place='top' effect='solid' disable={ this.shouldDisableTooltip("currentEmailField") }>{ this.state.defaultemail }</ReactTooltip>
                                    <a data-for="changeEmailAddress" data-tip className={ this.state.allowEmailUpdateRequest ? "changeEmail" : "changeEmail disabled" } onClick={ (event) => this.showEmailUpdatePopup(event) } style={ { cursor: "pointer", pointerEvents: "auto" } } tabIndex={ 0 }>(Change email address)</a>
                                    <ReactToolTip id="changeEmailAddress" place='top' effect='solid' disable={ this.state.allowEmailUpdateRequest }>
                                        Action not allowed until basic profile details are submitted.
                                    </ReactToolTip>
                                </div>
                                <div className="pendingEmailCtnr" style={ { display: this.state.pendingEmailTransfer !== null ? "flex" : "none" } }>
                                    <label>Pending email verification</label>
                                    <span className="newEmail" id="newEmailField" data-tip data-for="newEmailField">{ this.state.pendingEmailTransfer?.new_email }</span>
                                    <ReactTooltip id="newEmailField" place='top' effect='solid' disable={ this.shouldDisableTooltip("newEmailField") }>{ this.state.pendingEmailTransfer?.new_email }</ReactTooltip>
                                    <div className="pending_btn_blk">
                                        <button type="button" className="resendEmail" onClick={ event => this.resendEmailUpdateEmailHandler(event) }>Resend email</button>
                                        <button type="button" className="" onClick={ event => this.cancelEmailUpdate(event) }>Cancel</button>
                                    </div>
                                </div>
                                <span className="err_msg" style={ { display: this.state.showEmailUpdateError ? "block" : "none" } }>Error message goes here</span>
                            </div>
                        </div>
                        <div className="field_wrap setPassword">
                            <div className="gsignupWrap" style={ { display: this.state.isthirdpartylogin ? "flex" : "none" } }>
                                <div className="common_txtBox_row gsignup_opt">
                                    <div className="gsignup_blk">
                                        <div className="gsignup_lft">
                                            <label className="gsignup_label">
                                                <i>
                                                    { this.state.thirdPartyName === 'GitHub' ?
                                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 30 30"
                                                            class="abcRioButtonSvg"><path d="M15,0.3C6.8,0.3,0.1,7,0.1,15.2c0,7,4.8,12.8,11.3,14.5c-0.1-0.2-0.1-0.4-0.1-0.7v-2.5c-0.6,0-1.6,0-1.9,0 c-1,0-1.9-0.4-2.4-1.3c-0.5-0.9-0.6-2.3-1.8-3.1c-0.4-0.3-0.1-0.6,0.3-0.6c0.8,0.2,1.4,0.7,2,1.5c0.6,0.8,0.9,1,2,1 c0.5,0,1.3,0,2.1-0.2c0.4-1,1.1-2,2-2.4c-5-0.5-7.3-3-7.3-6.3c0-1.4,0.6-2.8,1.7-4C7.6,9.8,7.2,7.4,8.1,6.5c2.2,0,3.6,1.4,3.9,1.8 c1.1-0.4,2.3-0.6,3.6-0.6c1.3,0,2.5,0.2,3.6,0.6c0.3-0.4,1.7-1.8,3.9-1.8c0.9,0.9,0.5,3.3,0.1,4.5c1,1.2,1.7,2.6,1.7,4 c0,3.4-2.4,5.8-7.3,6.3c1.4,0.7,2.4,2.7,2.4,4.2V29c0,0.1,0,0.2,0,0.3c5.8-2,10-7.6,10-14.1C29.9,7,23.2,0.3,15,0.3z"></path>
                                                        </svg> :
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M14.72 8.15887C14.72 7.66251 14.6755 7.18523 14.5927 6.72705H8V9.43478H11.7673C11.605 10.3098 11.1118 11.0511 10.3705 11.5475V13.3039H12.6327C13.9564 12.0852 14.72 10.2907 14.72 8.15887Z" fill="#4285F4" />
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M7.99984 15.0001C9.88984 15.0001 11.4744 14.3733 12.6326 13.3042L10.3703 11.5478C9.74348 11.9678 8.94166 12.216 7.99984 12.216C6.17666 12.216 4.63348 10.9846 4.08302 9.33008H1.74438V11.1437C2.8962 13.4314 5.26348 15.0001 7.99984 15.0001Z" fill="#34A853" />
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M4.08318 9.33008C3.94318 8.91008 3.86364 8.46145 3.86364 8.00008C3.86364 7.53872 3.94318 7.09008 4.08318 6.67008V4.85645H1.74455C1.27045 5.80145 1 6.87054 1 8.00008C1 9.12963 1.27045 10.1987 1.74455 11.1437L4.08318 9.33008Z" fill="#FBBC05" />
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M7.99993 3.78409C9.02766 3.78409 9.95039 4.13727 10.6758 4.83091L12.6836 2.82318C11.4713 1.69364 9.88675 1 7.99993 1C5.26357 1 2.89629 2.56864 1.74448 4.85636L4.08311 6.67C4.63357 5.01545 6.17675 3.78409 7.99993 3.78409Z" fill="#EA4335" />
                                                        </svg>
                                                    }

                                                </i>{ this.state.thirdPartyName }</label>
                                            <span>{ this.state.email }</span>
                                        </div>
                                        <div className="gsignup_rgt">
                                            <a className="open_resetPopup" style={ { cursor: "pointer", pointerEvents: "auto" } } onClick={ this.enablePopupPassword }>Set password</a>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="resend_ctnr">
                                    <div className="resend_blk">
                                        <p>
                                        An email with further instructions has been sent to <strong>{this.state.email}</strong>
                                        </p>
                                    </div>
                                    <div className="btn_blk">
                                        <input type="submit" name="" className="common_cta_btn blue" value="Resend Email"/>
                                        <input type="button" name="" className="common_cta_btn transparentGrey" value="Cancel"/>
                                    </div>
                                </div> */}


                            </div>
                        </div>
                    </div>
                    <div className="field_sec_wrap field_wrap_phone">
                        <h3>Phone Number</h3>
                        <div className="field_wrap">
                            <div className="common_txtBox_row">
                                <label>Country Code</label>
                                <div className="custom_select_box coutry_code_wrap" >
                                    <select name="countryCode" id="countryCode" value={ this.state.countryCode } onChange={ this.handleInputs }>
                                        <option value="" style={ { display: "none" } } disabled={ true }>Select the country code</option>
                                        <option value="USA +1">USA +1</option>
                                        <option value="Afghanistan +93">Afghanistan +93 </option>
                                        <option value="Albania +355">Albania +355 </option>
                                        <option value="Algeria +213">Algeria +213 </option>
                                        <option value="American Samoa +684">American Samoa +684 </option>
                                        <option value="Andorra +376">Andorra +376 </option>
                                        <option value="Angola +244">Angola +244 </option>
                                        <option value="Anguilla +1-264">Anguilla +1-264 </option>
                                        <option value="Antarctica +672">Antarctica +672 </option>
                                        <option value="Antigua and Barbuda +1-268">Antigua and Barbuda +1-268 </option>
                                        <option value="Argentina +54">Argentina +54 </option>
                                        <option value="Armenia +374">Armenia +374 </option>
                                        <option value="Aruba +297">Aruba +297 </option>
                                        <option value="Australia +61">Australia +61 </option>
                                        <option value="Austria +43">Austria +43 </option>
                                        <option value="Azerbaijan +994">Azerbaijan +994 </option>
                                        <option value="Bahamas +1-242">Bahamas +1-242 </option>
                                        <option value="Bahrain +973">Bahrain +973 </option>
                                        <option value="Bangladesh +880">Bangladesh +880 </option>
                                        <option value="Barbados +1-246">Barbados +1-246 </option>
                                        <option value="Belarus +375">Belarus +375 </option>
                                        <option value="Belgium +32">Belgium +32 </option>
                                        <option value="Belize +501">Belize +501 </option>
                                        <option value="Benin +229">Benin +229 </option>
                                        <option value="Bermuda +1-441">Bermuda +1-441 </option>
                                        <option value="Bhutan +975">Bhutan +975 </option>
                                        <option value="Bolivia +591">Bolivia +591 </option>
                                        <option value="Bosnia-Herzegovina +387">Bosnia-Herzegovina +387 </option>
                                        <option value="Botswana +267">Botswana +267 </option>
                                        <option value="Brazil +55">Brazil +55 </option>
                                        <option value="Brunei Darussalam +673">Brunei Darussalam +673 </option>
                                        <option value="Bulgaria +359">Bulgaria +359 </option>
                                        <option value="Burkina Faso +226">Burkina Faso +226 </option>
                                        <option value="Burundi +257">Burundi +257 </option>
                                        <option value="Cambodia +855">Cambodia +855 </option>
                                        <option value="Cameroon +237">Cameroon +237 </option>
                                        <option value="Canada +1">Canada +1 </option>
                                        <option value="Cape Verde +238">Cape Verde +238 </option>
                                        <option value="Cayman Islands +1-345">Cayman Islands +1-345 </option>
                                        <option value="Central African Republic +236">Central African Republic +236 </option>
                                        <option value="Chad +235">Chad +235 </option>
                                        <option value="Chile +56">Chile +56 </option>
                                        <option value="China +86">China +86 </option>
                                        <option value="Christmas Island +61">Christmas Island +61 </option>
                                        <option value="Cocos (Keeling) Islands +61">Cocos (Keeling) Islands +61 </option>
                                        <option value="Colombia +57">Colombia +57 </option>
                                        <option value="Comoros +269">Comoros +269 </option>
                                        <option value="Congo +242">Congo +242 </option>
                                        <option value="Congo, Dem. Republic +243">Congo, Dem. Republic +243 </option>
                                        <option value="Cook Islands +682">Cook Islands +682 </option>
                                        <option value="Costa Rica +506">Costa Rica +506 </option>
                                        <option value="Croatia +385">Croatia +385 </option>
                                        <option value="Cuba +53">Cuba +53 </option>
                                        <option value="Cyprus +357">Cyprus +357 </option>
                                        <option value="Czech Rep. +420">Czech Rep. +420 </option>
                                        <option value="Denmark +45">Denmark +45 </option>
                                        <option value="Djibouti +253">Djibouti +253 </option>
                                        <option value="Dominica +1-767">Dominica +1-767 </option>
                                        <option value="Dominican Republic +809">Dominican Republic +809 </option>
                                        <option value="Ecuador +593">Ecuador +593 </option>
                                        <option value="Egypt +20">Egypt +20 </option>
                                        <option value="El Salvador +503">El Salvador +503 </option>
                                        <option value="Equatorial Guinea +240">Equatorial Guinea +240 </option>
                                        <option value="Eritrea +291">Eritrea +291 </option>
                                        <option value="Estonia +372">Estonia +372 </option>
                                        <option value="Ethiopia +251">Ethiopia +251 </option>
                                        <option value="Falkland Islands (Malvinas) +500">Falkland Islands (Malvinas) +500 </option>
                                        <option value="Faroe Islands +298">Faroe Islands +298 </option>
                                        <option value="Fiji +679">Fiji +679 </option>
                                        <option value="Finland +358">Finland +358 </option>
                                        <option value="France +33">France +33 </option>
                                        <option value="French Guiana +594">French Guiana +594 </option>
                                        <option value="Gabon +241">Gabon +241 </option>
                                        <option value="Gambia +220">Gambia +220 </option>
                                        <option value="Georgia +995">Georgia +995 </option>
                                        <option value="Germany +49">Germany +49 </option>
                                        <option value="Ghana +233">Ghana +233 </option>
                                        <option value="Gibraltar +350">Gibraltar +350 </option>
                                        <option value="Great Britain +44">Great Britain +44 </option>
                                        <option value="Greece +30">Greece +30 </option>
                                        <option value="Greenland +299">Greenland +299 </option>
                                        <option value="Grenada +1-473">Grenada +1-473 </option>
                                        <option value="Guadeloupe (French) +590">Guadeloupe (French) +590 </option>
                                        <option value="Guam (USA) +1-671">Guam (USA) +1-671 </option>
                                        <option value="Guatemala +502">Guatemala +502 </option>
                                        <option value="Guinea +224">Guinea +224 </option>
                                        <option value="Guinea Bissau +245">Guinea Bissau +245 </option>
                                        <option value="Guyana +592">Guyana +592 </option>
                                        <option value="Haiti +509">Haiti +509 </option>
                                        <option value="Honduras +504">Honduras +504 </option>
                                        <option value="Hong Kong +852">Hong Kong +852 </option>
                                        <option value="Hungary +36">Hungary +36 </option>
                                        <option value="Iceland +354">Iceland +354 </option>
                                        <option value="India +91">India +91 </option>
                                        <option value="Indonesia +62">Indonesia +62 </option>
                                        <option value="Iran +98">Iran +98 </option>
                                        <option value="Iraq +964">Iraq +964 </option>
                                        <option value="Ireland +353">Ireland +353 </option>
                                        <option value="Israel +972">Israel +972 </option>
                                        <option value="Italy +39">Italy +39 </option>
                                        <option value="Ivory Coast +225">Ivory Coast +225 </option>
                                        <option value="Jamaica +1-876">Jamaica +1-876 </option>
                                        <option value="Japan +81">Japan +81 </option>
                                        <option value="Jordan +962">Jordan +962 </option>
                                        <option value="Kazakhstan +7">Kazakhstan +7 </option>
                                        <option value="Kenya +254">Kenya +254 </option>
                                        <option value="Kiribati +686">Kiribati +686 </option>
                                        <option value="Korea-North +850">Korea-North +850 </option>
                                        <option value="Korea-South +82">Korea-South +82 </option>
                                        <option value="Kuwait +965">Kuwait +965 </option>
                                        <option value="Kyrgyzstan +996">Kyrgyzstan +996 </option>
                                        <option value="Laos +856">Laos +856 </option>
                                        <option value="Latvia +371">Latvia +371 </option>
                                        <option value="Lebanon +961">Lebanon +961 </option>
                                        <option value="Lesotho +266">Lesotho +266 </option>
                                        <option value="Liberia +231">Liberia +231 </option>
                                        <option value="Libya +218">Libya +218 </option>
                                        <option value="Liechtenstein +423">Liechtenstein +423 </option>
                                        <option value="Lithuania +370">Lithuania +370 </option>
                                        <option value="Luxembourg +352">Luxembourg +352 </option>
                                        <option value="Macau +853">Macau +853 </option>
                                        <option value="Macedonia +389">Macedonia +389 </option>
                                        <option value="Madagascar +261">Madagascar +261 </option>
                                        <option value="Malawi +265">Malawi +265 </option>
                                        <option value="Malaysia +60">Malaysia +60 </option>
                                        <option value="Maldives +960">Maldives +960 </option>
                                        <option value="Mali +223">Mali +223 </option>
                                        <option value="Malta +356">Malta +356 </option>
                                        <option value="Marshall Islands +692">Marshall Islands +692 </option>
                                        <option value="Martinique (French) +596">Martinique (French) +596 </option>
                                        <option value="Mauritania +222">Mauritania +222 </option>
                                        <option value="Mauritius +230">Mauritius +230 </option>
                                        <option value="Mayotte +269">Mayotte +269 </option>
                                        <option value="Mexico +52">Mexico +52 </option>
                                        <option value="Micronesia +691">Micronesia +691 </option>
                                        <option value="Moldova +373">Moldova +373 </option>
                                        <option value="Monaco +377">Monaco +377 </option>
                                        <option value="Mongolia +976">Mongolia +976 </option>
                                        <option value="Montenegro +382">Montenegro +382 </option>
                                        <option value="Montserrat +1-664">Montserrat +1-664 </option>
                                        <option value="Morocco +212">Morocco +212 </option>
                                        <option value="Mozambique +258">Mozambique +258 </option>
                                        <option value="Myanmar +95">Myanmar +95 </option>
                                        <option value="Namibia +264">Namibia +264 </option>
                                        <option value="Nauru +674">Nauru +674 </option>
                                        <option value="Nepal +977">Nepal +977 </option>
                                        <option value="Netherlands +31">Netherlands +31 </option>
                                        <option value="Netherlands Antilles +599">Netherlands Antilles +599 </option>
                                        <option value="New Caledonia (French) +687">New Caledonia (French) +687 </option>
                                        <option value="New Zealand +64">New Zealand +64 </option>
                                        <option value="Nicaragua +505">Nicaragua +505 </option>
                                        <option value="Niger +227">Niger +227 </option>
                                        <option value="Nigeria +234">Nigeria +234 </option>
                                        <option value="Niue +683">Niue +683 </option>
                                        <option value="Norfolk Island +672">Norfolk Island +672 </option>
                                        <option value="Northern Mariana Islands +670">Northern Mariana Islands +670 </option>
                                        <option value="Norway +47">Norway +47 </option>
                                        <option value="Oman +968">Oman +968 </option>
                                        <option value="Pakistan +92">Pakistan +92 </option>
                                        <option value="Palau +680">Palau +680 </option>
                                        <option value="Panama +507">Panama +507 </option>
                                        <option value="Papua New Guinea +675">Papua New Guinea +675 </option>
                                        <option value="Paraguay +595">Paraguay +595 </option>
                                        <option value="Peru +51">Peru +51 </option>
                                        <option value="Philippines +63">Philippines +63 </option>
                                        <option value="Poland +48">Poland +48 </option>
                                        <option value="Polynesia (French) +689">Polynesia (French) +689 </option>
                                        <option value="Portugal +351">Portugal +351 </option>
                                        <option value="Puerto Rico +1-787">Puerto Rico +1-787 </option>
                                        <option value="Qatar +974">Qatar +974 </option>
                                        <option value="Reunion (French) +262">Reunion (French) +262 </option>
                                        <option value="Romania +40">Romania +40 </option>
                                        <option value="Russia +7">Russia +7 </option>
                                        <option value="Rwanda +250">Rwanda +250 </option>
                                        <option value="Saint Helena +290">Saint Helena +290 </option>
                                        <option value="Saint Kitts &amp; Nevis Anguilla +1-869">Saint Kitts &amp; Nevis Anguilla +1-869 </option>
                                        <option value="Saint Lucia +1-758">Saint Lucia +1-758 </option>
                                        <option value="Saint Pierre and Miquelon +508">Saint Pierre and Miquelon +508 </option>
                                        <option value="Saint Vincent &amp; Grenadines +1-784">Saint Vincent &amp; Grenadines +1-784 </option>
                                        <option value="Samoa +684">Samoa +684 </option>
                                        <option value="San Marino +378">San Marino +378 </option>
                                        <option value="Sao Tome and Principe +239">Sao Tome and Principe +239 </option>
                                        <option value="Saudi Arabia +966">Saudi Arabia +966 </option>
                                        <option value="Senegal +221">Senegal +221 </option>
                                        <option value="Serbia +381">Serbia +381 </option>
                                        <option value="Seychelles +248">Seychelles +248 </option>
                                        <option value="Sierra Leone +232">Sierra Leone +232 </option>
                                        <option value="Singapore +65">Singapore +65 </option>
                                        <option value="Slovakia +421">Slovakia +421 </option>
                                        <option value="Slovenia +386">Slovenia +386 </option>
                                        <option value="Solomon Islands +677">Solomon Islands +677 </option>
                                        <option value="Somalia +252">Somalia +252 </option>
                                        <option value="South Africa +27">South Africa +27 </option>
                                        <option value="Spain +34">Spain +34 </option>
                                        <option value="Sri Lanka +94">Sri Lanka +94 </option>
                                        <option value="Sudan +249">Sudan +249 </option>
                                        <option value="Suriname +597">Suriname +597 </option>
                                        <option value="Swaziland +268">Swaziland +268 </option>
                                        <option value="Sweden +46">Sweden +46 </option>
                                        <option value="Switzerland +41">Switzerland +41 </option>
                                        <option value="Syria +963">Syria +963 </option>
                                        <option value="Taiwan +886">Taiwan +886 </option>
                                        <option value="Tajikistan +992">Tajikistan +992 </option>
                                        <option value="Tanzania +255">Tanzania +255 </option>
                                        <option value="Thailand +66">Thailand +66 </option>
                                        <option value="Togo +228">Togo +228 </option>
                                        <option value="Tokelau +690">Tokelau +690 </option>
                                        <option value="Tonga +676">Tonga +676 </option>
                                        <option value="Trinidad and Tobago +1-868">Trinidad and Tobago +1-868 </option>
                                        <option value="Tunisia +216">Tunisia +216 </option>
                                        <option value="Turkey +90">Turkey +90 </option>
                                        <option value="Turkmenistan +993">Turkmenistan +993 </option>
                                        <option value="Turks and Caicos Islands +1-649">Turks and Caicos Islands +1-649 </option>
                                        <option value="Tuvalu +688">Tuvalu +688 </option>
                                        <option value="U.K. +44">U.K. +44 </option>
                                        <option value="Uganda +256">Uganda +256 </option>
                                        <option value="Ukraine +380">Ukraine +380 </option>
                                        <option value="United Arab Emirates +971">United Arab Emirates +971 </option>
                                        <option value="Uruguay +598">Uruguay +598 </option>
                                        <option value="Uzbekistan +998">Uzbekistan +998 </option>
                                        <option value="Vanuatu +678">Vanuatu +678 </option>
                                        <option value="Vatican +39">Vatican +39 </option>
                                        <option value="Venezuela +58">Venezuela +58 </option>
                                        <option value="Vietnam +84">Vietnam +84 </option>
                                        <option value="Virgin Islands (British) +1-28284">Virgin Islands (British) +1-28484 </option>
                                        <option value="Virgin Islands (USA) +1-34040">Virgin Islands (USA) +1-34040 </option>
                                        <option value="Wallis and Futuna Islands +681">Wallis and Futuna Islands +681 </option>
                                        <option value="Yemen +967">Yemen +967 </option>
                                        <option value="Zambia +260">Zambia +260 </option>
                                        <option value="Zimbabwe +263">Zimbabwe +263 </option>
                                    </select>
                                </div>
                                <span className="err_msg" style={ { display: this.state.countrycodeempty ? "inline-block" : "none" } }>Country code cannot be blank</span> </div>
                            <div className="common_txtBox_row">
                                <label>Number</label>
                                <input type="text" maxLength="20" autoComplete="off" ref={ this.phoneNumberFocus } name="phone" value={ this.state.phone } onFocus={ this.checkPhoneRegex(this.state.phone) } onChange={ this.handleInputs } className="txtBox" onKeyDown={ (e) => this.detailEnterKey(e) } />
                                <div className="id-tooltip id-tooltip-topright">
                                    <p className="id-tooltip-note">Use atleast:</p>
                                    <ul>
                                        <li id="min_sev">minimum of 7 characters </li>
                                        <li id="max_twe">maximum of 20 characters</li>
                                        <li id="no_spe">only characters 0-9 x X - + ()</li>
                                    </ul>
                                </div>
                                <span className="err_msg" style={ { display: this.state.phoneNumberEmpty ? 'inline-block' : 'none' } } >Phone Number cannot be blank</span>
                                <span className="err_msg" style={ { display: this.state.phoneregex ? 'inline-block' : 'none' } } >Phone number is invalid</span> </div>
                        </div>
                        {/* <p className="form_note">Your phone number may help us reach out to you for service related notifications and two-factor verification for enhanced security.</p> */ }
                        <p className="form_note">Your phone number may help us reach out to you for service related notifications.</p>
                    </div>
                    <div className="pwd_change_cta" onClick={ this.enablePopupPassword } style={ { display: !this.state.isthirdpartylogin ? "block" : "none" } }><a>Change Password</a></div>
                    <div className="terms_sec" style={ { display: "none" } }>
                        <label className="checkBox">
                            <input type="checkbox" />
                            <span className="checkmark"></span>
                            <p>Send me updates on IDrive Compute</p>
                        </label>
                    </div>
                    <input type="button" value="Save Changes" onClick={ this.saveChanges } className={ this.state.issaveenable ? "common_cta_btn blue" : "common_cta_btn blue disabled" } disabled={ !this.state.issaveenable } />
                    { !this.state.isUserSubscribed ?
                        <div className="cancel_acc_cta" id="cancelaccount" ><a onClick={ this.enableCancelPassword }>Cancel my account</a>{ this.state.roleId === "2" ? "(On cancelling your IDrive Compute account, all the linked resources and users will be deleted, and all your data will be removed.)" : "(On cancelling your IDrive Compute account,  you will not be able to access the resources (instances, images, volumes, backups, etc.) and all your data will be removed.)" }</div>
                        :
                        <div className="cancel_acc_cta" id="cancelaccount" ><a onClick={ this.cancelAccountFirstPopup }>Cancel my account</a>{ this.state.roleId === "2" ? "(On cancelling your IDrive Compute account, all the linked resources and users will be deleted, and all your data will be removed.)" : "(On cancelling your IDrive Compute account,  you will not be able to access the resources (instances, images, volumes, backups, etc.) and all your data will be removed.)" }</div>
                    }
                    <CommonMessage message={ this.state.message } msgType={ this.state.msgType } handler={ () => this.setState({ message: '' }) } />
                </section>

                {/** POPUP CODE */ }

                { /** START Change password popup */ }
                <div className={ this.state.isChangePsswdPopup ? "main_popup accModule_changePwd_popup active" : "main_popup accModule_changePwd_popup" } >

                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ (e) => this.closePasswordPopup(e) }></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Change Password</div>
                                </div>
                                <form onSubmit={ (e) => this.changePsswdFormSubmit(e) }>
                                    <div className="popup_body">
                                        <div className="common_txtBox_row">
                                            <label>Current password</label>
                                            <div className="auth_box_wrap">
                                                <input id="currentPsswdFocus" ref={ this.currentPsswdFocus } type={ this.state.getcurpswd ? "text" : "password" } value={ this.state.changePsswdForm.currentPsswd } name="currentPsswd" className="txtBox" onChange={ this.ChangePsswdHandler } />
                                                <span className={ this.state.getcurpswd ? "pwd_field show_pwd" : "pwd_field" } data-tip data-for="popupcurntpassword" onClick={ () => this.showCurPswd("current") }></span>
                                                <ReactToolTip id="popupcurntpassword" effect="solid">
                                                    { this.state.getcurpswd ? "Hide" : "Show" }
                                                </ReactToolTip>
                                            </div>
                                            <span className="err_msg" style={ { display: this.state.curpswderror ? 'inline-block' : 'none', color: "red" } } >Current password is not correct</span>
                                            <span className="err_msg" style={ { display: this.state.curpswdempty ? 'inline-block' : 'none', color: "red" } } >Current password cannot be blank</span>
                                        </div>
                                        <div className="common_txtBox_row">
                                            <label>New password</label>
                                            <div className="auth_box_wrap">
                                                <input ref={ this.changeNewPassword } type={ this.state.getnewpswd ? "text" : "password" } value={ this.state.changePsswdForm.newPsswd } name="newPsswd" className="txtBox" onChange={ this.ChangePsswdHandler } onClick={ (e) => this.editPasswordFocus(e, "newpaswd") } onFocus={ (e) => this.editPasswordFocus(e, "newpaswd") } />
                                                <div className="id-tooltip id-tooltip-topright new-pass">
                                                    <p className="id-tooltip-note">Use atleast:</p>
                                                    <ul>
                                                        <li id="upperCaseLi">1 uppercase character</li>
                                                        <li id="lowerCaseLi">1 lowercase character</li>
                                                        <li id="numericLi">1 numerical digit</li>
                                                        <li id="specCharLi">1 special character</li>
                                                        <li id="eightCharLi">Min 8 characters</li>
                                                    </ul>
                                                </div>
                                                <span className={ this.state.getnewpswd ? "pwd_field show_pwd" : "pwd_field" } data-tip data-for="popupnewpassword" onClick={ () => this.showCurPswd("new") }></span>
                                                <ReactToolTip id="popupnewpassword" effect="solid">
                                                    { this.state.getnewpswd ? "Hide" : "Show" }
                                                </ReactToolTip>
                                            </div>
                                            {/* {this.state.psswdStrength !=""?
                                            <div className="auth_progress">
                                                <div className={this.state.psswdStrength === "Weak"?"progress_wrap weak":"progress_wrap strong"}>
                                                    <div className="progress_bar">
                                                    {this.state.psswdStrength==='Weak' && (<span
                                                        className="percent_progress"
                                                        style={{
                                                        width: "20%"
                                                    }}></span>)
                                                   }
                                                   {this.state.psswdStrength==='Average' && (<span
                                                        className="percent_progress"
                                                        style={{
                                                        width: "45%"
                                                    }}></span>)
                                                   }
                                                   {this.state.psswdStrength==='Strong' && (<span
                                                        className="percent_progress"
                                                        style={{
                                                        width: "100%"
                                                    }}></span>)
                                                   }
                                                    </div>
                                                    <span className="progress_content">{this.state.psswdStrength}</span>
                                                    {this.state.psswdStrength==='Weak'? <p>Your password is weak. Choose a stronger password.</p>:""}
                                               
                                                </div>
                                            </div>:""} */}
                                            <span className="err_msg" style={ { display: this.state.pswdempty ? 'inline-block' : 'none', color: "red" } }>New password cannot be blank</span>
                                            <span className="err_msg" style={ { display: this.state.pswdregex ? 'inline-block' : 'none', color: "red" } }>Password must meet the criteria</span>
                                            <span className="err_msg" style={ { display: this.state.ispswdsame ? 'inline-block' : 'none', color: "red" } }>Current password and new password cannot be same</span>
                                        </div>
                                        <div className="common_txtBox_row">
                                            <label>Confirm password</label>
                                            <div className="auth_box_wrap">
                                                <input type={ this.state.getConfmPass ? "text" : "password" } ref={ this.changeConfirmPassword } name="confirmPsswd" value={ this.state.changePsswdForm.confirmPsswd } className="txtBox" onChange={ this.ChangePsswdHandler } onClick={ (e) => this.editPasswordFocus(e, "cnfrmpswd") } onFocus={ (e) => this.editPasswordFocus(e, "cnfrmpswd") } />
                                                <span className={ this.state.getConfmPass ? "pwd_field show_pwd" : "pwd_field" } data-tip data-for="popupconfrim" onClick={ () => this.showCurPswd("confirmpass") }></span>
                                                <ReactToolTip id="popupconfrim" effect="solid">
                                                    { this.state.getConfmPass ? "Hide" : "Show" }
                                                </ReactToolTip>
                                            </div>

                                            <span className="err_msg" style={ { display: this.state.confirmpswderror ? 'inline-block' : 'none', color: "red" } } >New password and confirmation password must be same</span>
                                        </div>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns button_inverse">
                                            <button className={ this.state.isPaswdUpdateDisable ? "btn blue disabled" : "btn blue" } id="updatepswd" onClick={ (e) => this.changePsswdFormSubmit(e) } disabled={ this.state.isPaswdUpdateDisable }>Update</button>
                                            <button className="btn btn_cancel" onClick={ (e) => this.closePasswordPopup(e) }>Cancel</button>



                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                { /** END Change password popup */ }

                {/** START Cancel account popup */ }
                <div className={ this.state.isCancelMyAccount ? "main_popup accModule_cancelAcc_popup active" : "main_popup accModule_cancelAcc_popup" }>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ (e) => this.cancelPopup() }></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Are you sure you want to cancel your account</div>
                                </div>
                                <div className="cancel_acc_step1">
                                    <div className="popup_body">
                                        { this.state.roleId === "2" ?
                                            <p className="info_txt">This will permanently delete your account with all the associated resources (instances, images, volumes, backups, etc.) and users along with the existing data. This operation is irreversible. The user must clear all dues.</p>
                                            :
                                            <p className="info_txt">This will permanently delete your account and you will not be able to access the resources (instances, images, volumes, backups, etc.). </p>
                                        }

                                        <div className="field_sec_wrap col_two">
                                            <div className="common_txtBox_row">
                                                <label>Email Address</label>
                                                <input type="text" name="cancelemail" defaultValue={ this.state.email } onClick={ (e) => this.inputFocus(e, "email") } onFocus={ (e) => this.inputFocus(e, "email") } className="txt_box disabled" readOnly />

                                            </div>

                                        </div>
                                        <div className="field_sec_wrap col_two">
                                            <div className="common_txtBox_row" style={ { display: this.state.isthirdpartylogin ? "none" : "block" } }>
                                                <label>Password</label>
                                                <div className="auth_box_wrap">
                                                    <input type={ this.state.hideCancelPopupPwd ? "password" : "text" } ref={ this.cancelPswdFocus } value={ this.state.cancelpassword } name="cancelpassword" className="txt_box" onChange={ this.handleInputs } />
                                                    <span className={ this.state.isCancelPswd ? "pwd_field show_pwd" : "pwd_field" } data-tip data-for="cancelpd" onClick={ () => this.cancelPasswdShow() }></span><ReactToolTip />
                                                </div>
                                                <ReactToolTip id="cancelpd" effect="solid">
                                                    { this.state.hideCancelPopupPwd ? "Show" : "Hide" }
                                                </ReactToolTip>
                                                <span className="err_msg" style={ { display: this.state.cancelpswdempty ? 'inline-block' : 'none' } } >Password cannot be blank</span>
                                                <span className="err_msg" style={ { display: this.state.invalidpassword ? 'inline-block' : 'none' } } >Incorrect password</span>
                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>Phone Number</label>
                                                <input type="text" name="cancelphone" maxLength="20" value={ this.state.cancelphone } ref={ this.cancelPhoneFocus } onClick={ (e) => this.inputFocus(e, "phoneNumber") } onFocus={ (e) => this.inputFocus(e, "phoneNumber") } className="txt_box" onChange={ this.handleInputs } />
                                                <div className="id-tooltip id-tooltip-topright">
                                                    <p className="id-tooltip-note">Use atleast:</p>
                                                    <ul>
                                                        <li className={ this.state.sevenChars ? "success" : "" }>minimum of 7 characters </li>
                                                        <li className={ this.state.twentyChars ? "success" : "" }>maximum of 20 characters</li>
                                                        <li className={ this.state.npSpecial ? "success" : "" }>only characters 0-9 x X - + ()</li>
                                                    </ul>
                                                </div>
                                                <span className="err_msg" style={ { display: this.state.cancelphoneempty ? 'inline-block' : 'none' } } >Phone Number cannot be blank</span>
                                                <span className="err_msg" style={ { display: this.state.invalidphone ? 'inline-block' : 'none' } } >Phone number is invalid</span>
                                            </div>

                                        </div>
                                        <div className="field_sec_wrap">
                                            <div className="common_txtBox_row">
                                                <div className="custom_select_box selctReasonCancel" ref={ this.cancelReasonFocus }>
                                                    <select name="cancelreason" value={ this.state.cancelreason } onChange={ this.handleInputs } onClick={ (e) => this.inputFocus(e, "options") } onFocus={ (e) => this.inputFocus(e, "options") }>
                                                        <option value="" style={ { display: "none" } }>Select a reason</option>
                                                        <option value="IDrive Compute solution is not affordable for me">IDrive Compute solution is not affordable for me</option>
                                                        <option value="IDrive Compute customer support was not helpful">IDrive Compute customer support was not helpful</option>
                                                        <option value="IDrive Compute has connectivity issues">IDrive Compute has connectivity issues</option>
                                                        <option value="IDrive Compute does not have the necessary features">IDrive Compute does not have the necessary features</option>
                                                        <option value="IDrive Compute has several bugs">IDrive Compute has several bugs</option>
                                                        <option value="IDrive Compute is no longer needed">IDrive Compute is no longer needed</option>
                                                        <option value="Others">Others (Use the Comments box below)</option>
                                                    </select>
                                                </div>
                                                <span className="err_msg" style={ { display: this.state.cancelreasonempty ? 'inline-block' : 'none' } } >Please select reason</span>
                                            </div>
                                        </div>
                                        <div className="field_sec_wrap">
                                            <div className="common_txtBox_row">
                                                <textarea placeholder="Comments" maxLength="150" value={ this.state.cancelcomments } name="cancelcomments" ref={ this.cancelCommentsFocus } onClick={ (e) => this.inputFocus(e, "comments") } onFocus={ (e) => this.inputFocus(e, "comments") } onChange={ this.handleInputs }></textarea>
                                                <span className="err_msg" style={ { display: this.state.cancelcommentsempty ? 'inline-block' : 'none' } } >Comments cannot be empty when 'others' reason is selected</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button className="btn blue" onClick={ this.cancelSubuserAcccont }>Cancel my account</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="cancel_acc_step2">
                                    <div className="popup_body">
                                        <p>This action is irreversible. Your account with all the associated resources (instances, images, volumes, backups, etc.) and users along with the existing data will be permanently deleted. Any usage charges will be deducted from the credit card linked to your account.</p>
                                        <p className="usage-amt">Usage Amount: <span>${ this.state.totalAmount }</span></p>
                                        <p className="info">We highly recommend that you continue using IDrive Compute.</p>
                                        <p className="cancel-note"><b>Note</b>: Any charges incurred will not be refunded on deleting the prepaid yearly instance.</p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button value="" className="btn red" onClick={ this.cancelAccountSecondPopup } >Cancel My Account</button>
                                            <button value="" className="btn blue" onClick={ this.keepMyAcccount }> Keep My Account</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/** END Cancel account popup */ }

                {/** START Phone verification popup */ }
                <div className={ this.state.isPhoneVerifyPopup ? "main_popup accModule_mobileOtp_popup active" : "main_popup accModule_mobileOtp_popup" }>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ this.closePhoneVerifyPopup }></span>
                                <div className="popup_header">
                                    <div className="sub_title">Verify Phone Number</div>
                                </div>
                                <div className="popup_body">
                                    <div className="common_txtBox_row">
                                        <p className="resend_msg" id="resend_msg" style={ { display: "none" } }>Verification code has been resent.</p>
                                        <p className="resend_msg" id="verify_otp_msg" style={ { display: "none" } }>Error occured. Enter a valid OTP.</p>
                                        <p>A one time password has been sent to <b>{ this.state.countryLabel }{ this.state.phone }</b></p>
                                        <label>Enter the OTP to verify your phone number</label>
                                        <input type="password" ref={ this.otpInput } name="otp" id="otp" value={ this.state.otp } className="txtBox" maxLength="6" onChange={ this.handleInputs } onKeyUp={ this.handleOTPKeyUp } />
                                        <span className="err_msg" style={ { display: this.state.otpempty ? 'inline-block' : 'none' } } >Verification code cannot be blank</span>
                                        <span className="err_msg" style={ { display: this.state.otpErr ? 'inline-block' : 'none' } } >Enter a valid OTP</span>
                                    </div>
                                    <p className="otp-timer" id="otp_timer">Your verification code will expire in <b>04:13</b> Minutes</p>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns button_inverse">
                                            <button className="btn blue resend_btn" id="resend_btn" onClick={ () => this.reSendPhoneOtpByCaptcha() }>Resend OTP</button>
                                            <button className={ this.state.showVerifyLoader ? "btn blue verify_btn SubmitLoader" : "btn blue verify_btn" } id="verify_btn" onClick={ this.verifyOtp } >Verify</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/** END Phone verification popup */ }

                {/** START Reset password popup */ }
                <div className="main_popup resetPswd_popup">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" onClick={ () => this.hideSetPasswordPopup() }></span>
                                <div className="popup_header">
                                    <div className="sub_title">Set password</div>
                                </div>
                                <div className="popup_body">
                                    <div className="field_sec_wrap">
                                        <div className="common_txtBox_row">
                                            <p className="resetTitle"><b>A link with instructions to set a password will be sent to the email address provided here.</b></p>
                                            <span className="reset_info">You may need to check your spam folder or add <strong>support@idrive.com</strong> and <strong>support@send.idrive.com</strong> to your contact list to make sure that emails get delivered to your inbox.</span>
                                        </div>
                                    </div>
                                    <div className="common_txtBox_row">
                                        <label>Email Address</label>
                                        <input type="text" name="" value={ this.state.email } className="txtBox" disabled />
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <div className="btn blue verify_btn" onClick={ () => this.enableForgetPassword() }>Send Email</div>
                                            <div className="btn btn_cancel" onClick={ () => this.hideSetPasswordPopup() }>Cancel</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/** END Reset password popup */ }

                {/** START Email update popup */ }
                <div id="emailUpdatePopup" className={ this.state.isEmailUpdatePopupActive ? "main_popup updateEmail_popup active" : "main_popup updateEmail_popup" }>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap">
                                <span className="close_icon" data-for="updateEmailPopupCloseIcon" data-tip datatoggle="tooltip" title="" dataoriginaltitle="Close" onMouseDown={ (event) => this.closeEmailUpdatePopup(event) }></span>
                                <ReactTooltip id='updateEmailPopupCloseIcon' place='top' effect='solid'>Close</ReactTooltip>
                                <form id="updateEmailForm">
                                    <div className="popup_header">
                                        <div className="sub_title">Change Email Address</div>
                                    </div>
                                    <div className="popup_body">
                                        <div className={ this.state.popupMsgType_eu === 'error' ? "popup_msg error" : "popup_msg" } style={ { display: this.state.showPopupMsg_eu ? "block" : "none" } }>
                                            <div className="message_content">
                                                <p>{ this.state.popupMsg_eu }</p>
                                            </div>
                                        </div>
                                        <div className="common_txtBox_row">
                                            <label>New Email Address</label>
                                            <input type="email" name="updatedEmail" ref={ this.emailFocus } value={ this.state.updatedEmail } onChange={ event => this.emailUpdateInputHandler(event) } className="txtBox" onBlur={ event => this.validateUpdatedEmail(event) } onKeyDown={ event => this.emailUpdateInputReturnKeyHandler(event) } />
                                            <span className="err_msg" style={ { display: this.state.emailerror ? 'inline-block' : 'none', color: "red" } } >Email address already exists</span>
                                            <span className="err_msg" style={ { display: this.state.emailempty ? 'inline-block' : 'none' } } >Email address cannot be blank</span>
                                            <span className="err_msg" style={ { display: this.state.emailregex ? 'inline-block' : 'none' } } >Email address is invalid </span>
                                        </div>
                                        <div className="common_txtBox_row">
                                            <label>Current Password</label>
                                            <div className="auth_box_wrap">
                                                <input type={ this.state.isPswdVisible ? "text" : "password" } ref={ this.updateEmailPswdFocus } autoComplete='new-password' name="currPwd" value={ this.state.currPwd } onChange={ event => this.emailUpdatePwdInputHandler(event) } onBlur={ event => this.validateEmailUpdatePwd(event) } className="txtBox" onKeyDown={ event => this.emailUpdateInputReturnKeyHandler(event) } />
                                                <span data-tip="true" data-for="password" className={ this.state.isPswdVisible ? "pwd_field_eyeIcon show_pwd" : "pwd_field_eyeIcon" } currentitem="false" onClick={ (event) => this.togglePswdVisibility(event) }></span>
                                                <ReactTooltip id="password" place="right" effect="solid">
                                                    { this.state.isPswdVisible ? "Hide" : "Show" }
                                                </ReactTooltip>
                                            </div>
                                            <span className="err_msg" style={ { display: this.state.emptyPwd_eu ? 'inline-block' : 'none' } } >Password cannot be blank</span>
                                            <span className="err_msg" style={ { display: this.state.invalidPwd_eu ? 'inline-block' : 'none' } } >Incorrect password</span>
                                        </div>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <div id="submitEmailUpdateBtn" className="btn blue" tabIndex={ 0 } onClick={ event => this.validateAndSubmitEmailUpdateRequest(event) }>Change</div>
                                            <div className="btn btn_cancel" tabIndex={ 0 } onMouseDown={ () => this.closeEmailUpdatePopup() }>Cancel</div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {/** END Email update popup */ }

                <div className="captcha">
                    <ReCAPTCHA
                        sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
                        onChange={ (e) => this.onRecaptchaChange(e) }
                        ref={ this.recaptchaRef }
                        size="invisible"
                    />
                </div>
            </React.Fragment >
        );
    }
}
function getPsswdStrength(psswd) {
    const strongPwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-_+=(){}!@#\/\$%\^&\*:;'\"])(?=\\S+$)(?=.{8,})");
    const mediumPwd = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");

    if(strongPwd.test(psswd)) {
        return "Strong";
    }
    return "Weak";
} 
